<template>
  <div class="wrapper">
    <!--地图-->
    <div id="map" class="map"></div>

    <div id="myToolsAndPanels">
      <!-- <div class="mySlider">
        <a-slider :marks="marks" :step="null" :tipFormatter="null" :included="false" :dots="false" :defaultValue="0" @afterChange="sliderChange" />
      </div> -->
      <!--地图右侧按钮栏-->
      <div id="myToolBtns" :class="`mytool-btns2 ${/dashboard\/analysis/.test(pageHref)&&!fullScreen?'mytool-btns2-home':''}`">
        <div id="buttonDiv" style="float: left;display: inline-grid">
          <div class="navbtn-items2" v-if=lyrsBtnShow @click="triggerLayerSwitcher" title="图层" id="layerBtn">
            <!-- <img src="../../assets/map_icons/layer.png"> -->
            <img src="../../assets/RSsserviceManage/选择图层.png">
          </div>
          <div class="navbtn-items2" v-if=legendBtnShow @click="legendPanelVisible=!legendPanelVisible" title="图例" id="legendBtn">
            <img src="../../assets/map_icons/legend.png">
          </div>
          <!-- measureBtnShow -->
          <div class="navbtn-items2" v-if=false @click="measurePanelVisible=!measurePanelVisible" title="测量" id="measureBtn">
            <img src="../../assets/RSsserviceManage/测量.png">
          </div>
          <div class="navbtn-items2" v-if=juanlianShow @click="togglePanel('juanlianPanelVisible','juanlianFlag')" title="卷帘对比" id="compareBtn">
            <img src="../../assets/map_icons/compare.png">
          </div>
          <div class="navbtn-items2" v-if=blingblingBtn @click="toggleBling" title="开/关闪烁" id="blingblingBtn">
            <img src="../../assets/map_icons/blingbling.png">
          </div>
        </div>
      </div>
      <!--其他地图按钮-->

      <!--地图图例-->
      <div
      :class="`map-legend ${/dashboard\/analysis/.test(pageHref)?'map-legend-home':''}`"
        id="legendDiv"
        data-tool-panel-title="图例"
        onselectstart="return false"
        v-show="legendPanelVisible"
      >
        <div id="legend">
          <div class="rbody">
          </div>
        </div>
      </div>

      <div :class="`lyrPanal ${/dashboard\/analysis/.test(pageHref)&&!fullScreen?'lyrPanal-full':''}`" v-if="lyrPanal" @click="clickLyrPanal()">
        <div>
          <div><input data-name="status" data-cql="status='30'" name="未核查" type="checkbox" ><label style="color:#FF0000">未核查</label></div>
          <div><input data-name="status" data-cql="status='31'" name="核查未审核" type="checkbox" ><label style="color:#DB24FF">核查未审核</label></div>
          <div><input data-name="status" data-cql="status='32'" name="重新核查" type="checkbox" ><label style="color:#B74800">重新核查</label></div>
          <div><input data-name="status" data-cql="status='34'" name="未整改" type="checkbox" ><label style="color:#6F9000">未整改</label></div>
          <div><input data-name="status" data-cql="status='35'" name="整改未审核" type="checkbox" ><label style="color:#4BB47D">整改未审核</label></div>
          <div><input data-name="status" data-cql="(status='33' or status='36')" name="销号" type="checkbox" ><label style="color:#00FF00">销号</label></div>
          <!-- <div><input data-name="status" data-cql="status='32' && pszt='未整改' && psrq like '%07%'" name="卫星纠错" type="checkbox" ><label style="color:#BD53F2">卫星纠错</label></div>  -->
        </div>
      </div>

      <!--地图左上角工具栏对应的操作面板-->
      <!--图层管理面板-->
      <div
        :class="`layerBox ${/dashboard\/analysis/.test(pageHref)?'layerBox-home':''}`"
        :id="lyrBox"
        data-tool-panel-layer-title="Layers"
        onselectstart="return false"
      >
        <!-- <div id="panelHeader">
          <div class="options lyropt">
            <a-checkbox @change="handleAllLayers" style="color: rgb(0, 213, 255)">
              <span >显示全部图层</span>
            </a-checkbox>
            <a-checkbox @change="handleOpt" style="color: rgb(0, 213, 255)">透明度调节</a-checkbox>
          </div>
        </div> -->
      </div>

      <!--“工具箱”下拉-->
      <div
        class="tool-item-panel"
        id="mapDecorateTools"
        data-tool-panel-title="Decorate"
        v-if="toolBoxPanelVisible"
      >
        <div
          class="map-tool-item"
          title="量测"
          v-if="measureBtnShow"
          @click="measurePanelVisible=!measurePanelVisible"
        >
          <img src="../../assets/mapIcon/mapctrl/mcicons/Measurement.png" />
          <span>量测</span>
        </div>
        <div
          class="map-tool-item"
          title="图例"
          v-if="legendBtnShow"
          @click="legendPanelVisible=!legendPanelVisible"
        >
         <img src="../../assets/mapIcon/mapctrl/mcicons/Legend.png" />
          <span>图例</span>
        </div>
        <div
          class="map-tool-item"
          id="CoordinateDisplay"
          title="坐标"
          @click="coordinateShow=!coordinateShow"
        >
          <img src="../../assets/mapIcon/mapctrl/mcicons/Location.png" />
          <span>坐标</span>
        </div>
        <div class="map-tool-item" id="ScaleDisplay" title="比例尺" @click="scaleShow=!scaleShow">
          <img src="../../assets/mapIcon/mapctrl/mcicons/Scale.png" />
          <span>比例尺</span>
        </div>
      </div>

      <!--“量测”下拉-->
      <!-- <div
        class="tool-item-panel"
        id="mapMeasurementTools"
        data-tool-panel-title="Measurement"
        v-if="false"
      >
        <div class="map-tool-item" id="distance" title="测距离" @click="triggerDistance">
          <span>距离</span>
        </div>
        <div class="map-tool-item" id="area" title="测面积" @click="triggerArea">
          <span>面积</span>
        </div>
        <div class="map-tool-item" id="cleanMeasurement" title="清除量测结果" @click="triggerClean">
          <span>清除</span>
        </div>
      </div> -->

      <!-- 卷帘 -->
      <div class="juanlian" :class="{'layer-hide':juanlianPanelVisible}" title="卷帘控制" id="juanlian">
        <div style="display:block; margin-top:5px;">
          <img style="width:25px;height:25px;position:absolute;left:calc(50% - 3.5em)" src="../../assets/mapButton/卷帘控制.png" />
          <span style="font-size:1.2em;padding-left:5px;position:absolute;left:calc(50% - 1em);font-weight:bold;">卷帘控制</span>
        </div>
        <div style="position: absolute; left: 30px;top:40px;display:block">
          <table width="100%" border="0" align="center" cellpadding="2" cellspacing="1" >
            <tr>
              <td style="width:120px;font-weight:bold;" height="30" ><img style="width:20px;height:20px;" src="../../assets/mapButton/上层.png" />左侧/上侧：</td>
            </tr>
            <tr>
              <td align="center">
                <img style="width:20px;height:20px;" src="../../assets/mapButton/向下调节.png" />
                <select name="juanlianList1" id="juanlianList1" :disabled="!flagJL" style="width:100%;border:solid 2px #cecdd2;position:absolute;float:left;" placeholder="请选择图层">
                  <option value="" selected style="display: none">请选择图层</option>
                </select>
              </td>
            </tr>
            <tr>
              <td style="width:120px;font-weight:bold;" height="30" ><img style="width:20px;height:20px;" src="../../assets/mapButton/下层.png" />右侧/下侧：</td>
            </tr>
            <tr>
              <td align="center">
                <img style="width:20px;height:20px;" src="../../assets/mapButton/向上调节.png" />
                <select name="juanlianList2" id="juanlianList2" :disabled="!flagJL" style="width:100%;border:solid 2px #cecdd2;position:absolute;float:left;" placeholder="请选择图层">
                  <option value="" selected style="display: none">请选择图层</option>
                </select>
              </td>
            </tr>
          </table>
        </div>
        <div style="position: relative; top:160px; text-align:center">
          <input type="radio" name="rollerblind" id='verticalswipe' :disabled="!flagJL" checked/><label for='verticalswipe' style="font-weight:bold;">垂直方向</label>
          <input type="radio" name="rollerblind" id='horizontalswipe' :disabled="!flagJL" style="margin-left:30px;"/><label for='horizontalswipe' style="font-weight:bold;">水平方向</label>
        </div>
        <div style="position: absolute; bottom:10px;display:block;width:100%">
          <input type="button" id='juanlianButton' value="开始控制" @click="toggleJL()" style="width:100%;background-color: #1890FF;padding:5px;color:#FFFFFF;border-radius: 5px;"/>
        </div>
      </div>

      <div
        class="navbtn-drawer"
        title="打开/关闭数据面板"
        v-if="dataPanel"
        @click="triggerBus('drawer')"
      >
        <img id="drawer" src="../../assets/mapButton/展开.png" />
      </div>
      <!-- <div :class="`coordinateAndScaleBar ${/dashboard\/analysis/.test(pageHref)&&!fullScreen?'coordinateAndScaleBar-home':(fullScreen?'':'coordinateAndScaleBar-full')}`">
        地图比例尺
        <div id="scaleBarDiv" data-tool-panel-title="比例尺" v-show="scaleShow">
          <div id="scaleBar"></div>
        </div>
        地图坐标 (id必须为mouse-position，否则无法正常显示)
        <div
          class="map-decorate map-coordinate custom-mouse-position"
          id="mouse-position"
          data-tool-panel-title="坐标"
          v-show="coordinateShow"
        ></div>
      </div> -->
    </div>
    <!-- defaultChecked -->
    <!-- <a-checkbox  @change="showLabel" style="color: rgb(0, 213, 255);position:absolute;bottom:10px;left:10px;">文字标注</a-checkbox> -->
    <div v-if="showTools&&showBottomBar" :style="`position:absolute;right:0px;bottom: 0px;text-align:left;font-size:12px;width: ${showShootTime?'600px':'500px'};height:30px;line-height:30px;color: white;background-color: rgba(0,0,0,0.5);display: flex;`">
      <span v-show="mapNumber" style="margin-left: 20px;">审图号： {{ mapNumber }}</span>
      <span id="shootDate" v-show="showShootTime" style="margin-left: 20px;">拍摄时间：{{imagingTime}}</span>
      <!-- v-show="scaleShow" -->
      <div id="scaleBarDiv" data-tool-panel-title="比例尺" style="position: absolute;right: 153px;">
        <div id="scaleBar"></div>
      </div>
      <!-- class="map-decorate map-coordinate custom-mouse-position" v-show="coordinateShow"-->
      <div
        id="mouse-position"
        data-tool-panel-title="坐标"
        style="position:absolute;right: 23px;"
      ></div>
    </div>
    <!-- v-if="showTools" -->
    <SearchBar ref="searchBar" v-if="showTools&&showSearchBar&&flagJL"></SearchBar>



    <!-- 新的地图工具按钮 -->
    <div class="map_tool_shp" v-if="showTools&&drawFinished&&notAnnualPage">
      <!-- <img class="small_img" src="../../assets/RSsserviceManage/测量.png" title="加入我的矢量"/> -->
      <div class="tool_background">
        <img class="small_img" style="margin:2px 0" src="../../assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/添加到我的矢量.png" title="加入我的矢量" @click="makeVectorName=true"/>
      </div>
      <div class="tool_background">
        <img class="small_img" style="margin:2px 0" src="../../assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/下载矢量.png" title="下载矢量" @click="downloadShp"/>
      </div>
    </div>
    <div class="map_tool" v-if="showTools&&flagJL">
     <!--  <div class="btn" title="更多">
        <img class="small_img" src="../../assets/RSsserviceManage/更多.png"  @click="Home.showMoreToolsTipPanel=!Home.showMoreToolsTipPanel"/>
      </div> -->
      <div v-if="showVector&&juanlianBtnShow" class="btn" title="卷帘">
        <img class="small_img" src="../../assets/RSsserviceManage/套件使用逻辑素材/GIS工具栏/通用对比按钮.png"  @click="commonJuanLian"/>
      </div>
      <div v-if="showVector" class="btn" title="矢量" style="background-color: rgba(0,0,0,0.5);border-radius: 5px;margin-top: 2px;">
        <div style="width:40px;height:40px;display: flex;align-items: center;justify-content: center;" @click="drawBtnShow = !drawBtnShow">
          <img class="" :src="require(`../../assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/${drawSelected}.png`)" />
          <img style="position: absolute;transform: translate(-15px,15px);" src="../../assets/RSsserviceManage/套件使用逻辑素材/GIS工具栏/小三角形.png" />
        </div>
        <div class="vectorPanel" v-show="!drawDisabled">
          <div v-show="drawBtnShow" title="上传矢量文件" class="addVector" @click="changeDrawBtn('上传矢量文件')">
            <img src="../../assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/上传矢量文件.png">
          </div>
          <div v-show="drawBtnShow" title="选择行政区" class="selectRegion" @click="changeDrawBtn('行政区快选')">
            <img src="../../assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/行政区快选.png">
          </div>
          <div v-show="drawBtnShow" title="绘制折线" class="drawLine" @click="changeDrawBtn('绘制线矢量')">
            <img src="../../assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/绘制线矢量.png">
          </div>
          <div v-show="drawBtnShow" title="绘制多边形" class="drawPolygon" @click="changeDrawBtn('绘制多边形')">
            <img src="../../assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/绘制多边形.png">
          </div>
          <div v-show="drawFinished&&!isMeasure && drawBtnShow" title="清除绘制" @click="triggerClean();" class="clean">
            <img src="../../assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/清除按钮.png">
          </div>
          <div v-show="drawFinished && !isMeasure && !drawBtnShow" title="清除绘制" @click="triggerClean()" class="clean1">
            <img src="../../assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/清除按钮.png">
          </div>
        </div>
      </div>
      
      <div v-if="showMeasure" class="btn" title="量测" style="margin-top:2px">
        <img class="small_img" src="../../assets/RSsserviceManage/测量.png"  @click="measurePanelVisible=!measurePanelVisible"/>
        <div v-show="!drawDisabled" class="measurePanel">
          <!-- <div id="distance" title="测距离" @click="triggerDistance">
            <span>距离</span>
          </div>
          <div id="area" title="测面积" @click="triggerArea">
            <span>面积</span>
          </div>
          <div id="cleanMeasurement" title="清除量测结果" @click="triggerClean">
            <span>清除</span>
          </div> -->
          <div v-show="measurePanelVisible" title="测距离" @click="triggerDistance" class="distance">
            <img src="../../assets/RSsserviceManage/套件使用逻辑素材/测量工具集/测距.png">
          </div>
          <div v-show="measurePanelVisible" title="测面积" @click="triggerArea" class="area">
            <img src="../../assets/RSsserviceManage/套件使用逻辑素材/测量工具集/测面积.png">
          </div>
          <div v-show="drawFinished && isMeasure && measurePanelVisible" title="清除量测结果" @click="triggerClean" class="clean">
            <img src="../../assets/RSsserviceManage/套件使用逻辑素材/测量工具集/清除按钮.png">
          </div>
          <div v-show="drawFinished && isMeasure && !measurePanelVisible" title="清除量测结果" @click="triggerClean" class="clean1">
            <img src="../../assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/清除按钮.png">
          </div>
        </div>
      </div>
      <div class="btn" title="标注" style="margin:2px 0" @click="showLabel">
        <img class="small_img" v-if="labelShow" src="../../assets/RSsserviceManage/路网开.png" />
        <img class="small_img" v-else src="../../assets/RSsserviceManage/路网关.png" />
      </div>
      <div class="btn" title="放大" @click="triggerZoom(1)">
        <img class="small_img zoomOut" src="../../assets/RSsserviceManage/Zoom Out.png" />
      </div>
      <div class="btn zoomPanel" title="等级">
        <div class="zoomSpan">
          <span class="zoomTitle">Zoom</span>
          <span class="zoomValue">{{ zoomLevel }}</span>
        </div>
      </div>
      <div class="btn" title="缩小" @click="triggerZoom(0)">
        <img class="small_img zoomIn" src="../../assets/RSsserviceManage/Zoom In.png" />
      </div>
    </div>

    <div v-if="isSelectRegion" style="border-radius: 8px;width:600px;height:54px;position: absolute;left: calc(50% - 100px);top: 80px;background-color: rgba(0,0,0,0.75);display: flex;align-items: center;justify-content: center;">
      <!-- <div style="width:100px;">
        <v-select
          ref="chinaProvince"
          :items="chinaProvinceItems"
          item-text="areaName"
          item-value="areaId"
          :label="$vuetify.lang.t('$vuetify.search.rangeSelector.province')"
          v-model="chinaProvinceNow"
          dark
          dense
          outlined
        ></v-select>
      </div> -->
      <div style="width: 182px;margin-top: 28px;">
          <v-autocomplete
                  ref="chinaProvince"
                  class="ma-0 mr-2"
                  :items="chinaProvinceItems"
                  item-text="areaName"
                  item-value="areaId"
                  :label="$vuetify.lang.t('$vuetify.search.rangeSelector.province')"
                  v-model="chinaProvinceNow"
                  outlined
                  dark
                  dense
          ></v-autocomplete>
      </div>
      <div style="width: 182px;margin-top: 28px;">
          <v-autocomplete
                  ref="chinaCity"
                  class="ma-0 mr-2"
                  :disabled="!chinaProvinceNow"
                  :items="chinaCityItems"
                  item-text="areaName"
                  item-value="areaId"
                  :label="$vuetify.lang.t('$vuetify.search.rangeSelector.city')"
                  v-model="chinaCityNow"
                  outlined
                  dark
                  dense
          ></v-autocomplete>
      </div>
      <div style="width: 182px;margin-top: 28px;">
          <v-autocomplete
                  ref="chinaCounty"
                  class="ma-0"
                  :disabled="!chinaCityNow"
                  :items="chinaCountyItems"
                  item-text="areaName"
                  item-value="areaId"
                  :label="$vuetify.lang.t('$vuetify.search.rangeSelector.county')"
                  v-model="chinaCountyNow"
                  outlined
                  dark
                  dense
          ></v-autocomplete>
      </div>
    </div>
    <div v-if="isUploadVector" style="width:500px;position: absolute;left: calc(50% - 30px);top: calc(50% - 150px);">
      <img @click="isUploadVector=false;drawSelected='绘制多边形'" src="~@/assets/newHome/关闭.png" style="position: absolute;top: 0;right: -50px;cursor: pointer;">
      <SearchUploadFiles :justShow="true"/>
    </div>

    <div class="text-center" v-if="makeVectorName" style="z-index:1001">
      <v-dialog v-model="makeVectorName" width="800px" height="300px" content-class="mapDialog">
          <v-card
            height="300px"
            style="color:#FFFFFF ;position: relative;width: 800px;padding: 1px;z-index:1001;background-color: #2A2A2A;display: flex;align-items: center;justify-content: center;"
          >
          <!--关闭标签-->
          <img
              style="position: absolute; top: 10px;right:10px;z-index:1; cursor: pointer"
              src="~@/assets/RSsserviceManage/关闭.png"
              height="40"
              width="40"
              @click="makeVectorName = false;"
          />
          <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">

            <div>矢量命名</div>
            <div style="width:660px;margin-top: 50px;">
              <v-text-field
                v-model="createSearchName"
                :rules="[v => v.length <= 50 || '最多50个字符']"
                counter="50"
                dark
                outlined
                label="请输入矢量名称"
              ></v-text-field>
            </div>
            <div>
              <v-btn
                :disabled="createSearchName==''"
                class="ma-1"
                color="white"
                plain
                @click="addVectorSubmit(createSearchName)"
              >
                确定
              </v-btn>
              <v-btn
                class="ma-1"
                color="white"
                plain
                @click="makeVectorName = false;"
              >
                取消
              </v-btn>
  
            </div>
          </div>

          </v-card>
      </v-dialog>
    </div>

    <v-overlay :value="overlay">
      <span>正在处理，请稍后</span>
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :color=snackbarColor :timeout="timeout" bottom>
        {{snackbarInfo}}
        <v-btn dark text @click="snackbar = false" class="text-capitalize">
            {{$vuetify.lang.t('$vuetify.demand.close')}}</v-btn>
    </v-snackbar>
    <div v-if="showCountyTip" class="countyTip">购买专业版后可查看相应区域的18级切片影像</div>



    <!-- @click.self="show12LevelTip = false" -->
    <div
      v-show="show12LevelTip"
      class="ivm-flow-modal-mask"
    >
      <div class="ivm-flow-modal" role="dialog" aria-modal="true" aria-labelledby="ivm-flow-modal-title">
        <img
          src="~@/assets/RSsserviceManage/关闭反馈浮窗.png"
          alt="关闭"
          class="ivm-flow-modal-close"
          @click="show12LevelTip = false"
        >
        <div id="ivm-flow-modal-title" class="ivm-flow-modal-title">温馨提示</div>
        <div class="ivm-flow-modal-body">
          <p>该图源仅支持放大至12级，如需进一步浏览</p>
          <p>可前往遥感商城购买通用流量或图源包年</p>
        </div>
        <div class="ivm-flow-modal-footer">
          <button type="button" class="ivm-flow-modal-btn ivm-flow-modal-btn-primary" @click="$router.push('/')">
            立即前往
          </button>
          <button type="button" class="ivm-flow-modal-btn ivm-flow-modal-btn-ghost" @click="show12LevelTip = false">
            我知道了
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
  import Map from 'ol/Map'
  import View from 'ol/View'
  import { XYZ, OSM, Vector, ImageArcGISRest,TileArcGISRest, TileWMS, Cluster,ImageWMS,VectorTile } from 'ol/source'
  import { Tile, Group, Image, Vector as lVector, VectorTile as lVectorTile  } from 'ol/layer'
  import Feature from 'ol/Feature.js';
  import TileGrid from 'ol/tilegrid/TileGrid'
  import { createXYZ } from 'ol/tilegrid'
  import { Style, Fill, Stroke, Circle, Text, Circle as CircleStyle,Icon } from 'ol/style'
  import { unByKey } from 'ol/Observable'
  import Overlay from 'ol/Overlay'
  import { GeoJSON, WFS, WMSCapabilities,WMTSCapabilities,WMSGetFeatureInfo,MVT,WKT as fmtWKT } from 'ol/format'
  import { equalTo,bbox } from 'ol/format/filter'
  import { getArea, getLength } from 'ol/sphere'
  import { Polygon, LineString, MultiPolygon,MultiLineString, Point } from 'ol/geom'
  import { Draw, Select, Modify as iModify, DragBox, DoubleClickZoom } from 'ol/interaction'
  import { ScaleLine, MousePosition, defaults,Zoom } from 'ol/control'
  import { createStringXY,format as formatCoordinate } from 'ol/coordinate'
  import { fromLonLat,toLonLat,get as projGet } from 'ol/proj'
  import Legend from 'ol-ext/control/Legend'
  // import LayerSwitcher from 'ol-ext/control/LayerSwitcher'
  // import ol_ext_element from 'ol-ext/util/element'
  // import { httpAction } from '../../api/manage'
  import { platformModifierKeyOnly, singleClick } from 'ol/events/condition'
  import PopupFeature from 'ol-ext/overlay/PopupFeature'
  import Popup from 'ol-ext/overlay/Popup'
  import { createEmpty, extend, getWidth, getHeight,getCenter } from 'ol/extent'
  import Overview from 'ol-ext/control/Overview'
  import LayerSwitcherImage from 'ol-ext/control/LayerSwitcherImage'
  import Swipe from 'ol-ext/control/Swipe'
  import MapboxVectorLayer from 'ol/layer/MapboxVector';
  import SearchBar from './utils/SearchBar.vue'
  import coordtransform from 'coordtransform'
  import turf from "turf";
  import WKT from "terraformer-wkt-parser"
  import SearchUploadFiles from './SearchVector/SearchUploadFiles'
  import { GeometryToMulti, MultiToGeometry } from './utils/polygonHelp'
  import Print from 'ol-ext/control/Print'
  import { saveAs } from 'file-saver';
  import { AutoThematicMap } from '@/components/Maps/AutoThematicMap' //引入生成专题图功能
  import circle from '@turf/circle'
  import { createBox } from 'ol/interaction/Draw'
  import { china } from "../../../public/china";
  import booleanContains from '@turf/boolean-contains'
  import html2canvas from 'html2canvas';
  import md5 from 'js-md5';
  
  export default {
    name: 'MainMap',
    
    mixins: [AutoThematicMap],
    // inject: ["Home"],
    provide(){
      return{
          Search:this// 允许一个祖先组件向其所有子孙后代注入一个依赖，不论组件层次有多深，并在起上下游关系成立的时间里始终生效。
      }
    },
    components: {
      SearchBar,
      SearchUploadFiles,
    },
    props: {
      lyrdata: {
        type: Array,
        default: () => ([])
      },
      mapCtrlTools: {
        type: Array,
        default: () => ([])
      },
      mapServiceDist: {
        type: String,
        default: () => ('')
      },
      mapParams: {
        type: Object,
        default: () => ({})
      },
      taskStatus: {
        type: Array,
        default: () => ([])
      },
      fullScreen:{
        type: Boolean,
        default: false
      },
      showTools: {
        type: Boolean,
        default: true
      },
      notAnnualPage: {
        type: Boolean,
        default: true
      },
      showBottomBar: {
        type: Boolean,
        default: true
      },
      showSearchBar: {
        type: Boolean,
        default: true
      },
      showVector: {
        type: Boolean,
        default: true
      },
      showMeasure: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        /**地图左上角-功能启动图标按钮-初始化控制**/
        lyrsBtnShow: false, //图层管理控制-功能启动图标按钮，默认false不显示
        measureBtnShow: false, //测量工具-功能菜单启动图标按钮，默认false不显示
        decorateBtnShow: false, //地图整饰-功能菜单启动图标按钮，默认false不显示
        juanlianShow: false, //卷帘-功能菜单启动图标按钮，默认false不显示
        dataPanel: false, //打开/关闭数据面板-功能菜单启动图标按钮，默认false不显示
        legendBtnShow: false, //地图图例-功能菜单启动图标按钮，默认false不显示
        lyrPanal: false, //首页复选框-功能菜单启动图标按钮，默认false不显示
        blingblingBtn: false, //首页触发闪烁的按钮-功能菜单启动图标按钮，默认false不显示
        legendPanelVisible: false, //显示图例面板
        toolBoxPanelVisible: false, //工具箱下拉显示标识，默认是关闭状态
        measurePanelVisible: false, //量测下拉框显示标识，默认是关闭状态
        isMeasure: false, 
        POLYGON: '', //新绘制的图斑点坐标数组
        coordinateShow: true, //显示坐标
        scaleShow: true, //显示比例尺
        baseMap: [], //每个页面在myConf.js中配置的底图layers，在数据展示页面中使用
        checkedMapKey:[],//勾选的图层的key,在数据展示页面中使用
        mapLayersToShow: [], //从数据库中查询到的已发布到每个页面的显示图层后续合并到图层数组中 by qhy
        map: {},
        allHide: true,
        isEdit: false, //记录“业务数据管理”面板中的编辑按钮是否已点击
        defaultStylesForOwnShipData: [], //初始化读过来的权属数据的样式
        // fullScreen:false,//全屏
        cluResolution:this.GLOBAL.CLUSTER.RESOLUTION,//用于配置矢量图层和集群的临界点的分辨率
        cluDistance:this.GLOBAL.CLUSTER.DISTANCE,//集群的参数distance

        juanlianPanelVisible:true,  //默认true为隐藏
        flagJL:true,//卷帘控制切换开关标志
        swipe:{},//卷帘control
        notJLLayers:[],//保存此时不卷帘且visible为true的图层数组
        JLLeftlyr:{},//新卷帘左图层
        JLRightlyr:{},//新卷帘右图层
        // JLlyrs:[],//新卷帘左右图层
        url: {
          list: "/business/business/list",
        },
        // mapMarks: this.GLOBAL.mapMarks,
        featureTypesForAttr:[],//属性
        switcher:{},//图层面板控件

        departname:[],//部门名分成的区名和部门名，用于根据所属区和部门显示图斑

        cqlFromTab:'',//成果统计中各个tab传过来的cql
        cqlInterval:null,//切换cql时创建的定时器

        // black_waterUrl:`http://202.111.178.10:34573/geoserver/black_water/wms?service=WMS&version=1.1.0&request=GetMap&layers=black_water:black_water_business&styles=`,

        //
        black_waterPointUrl:`http://121.36.101.27:8000/geoserver/blackwater/wms?service=WMS&version=1.1.0&request=GetMap&layers=blackwater:business&styles=`,

        cqlUrl:'',//如果卫星纠错被勾选，则url为luotuweixingshenhe的，否则为luotu的
        // cqlUrl1:'',//如果卫星纠错被勾选，则url为luotuweixingshenhe的，否则为luotu的
        checkedNames:[],//保存首页左下角被勾选的名字
        cqlsForBling:[],//第一个只有静止的组合的cql，第二个是全都有的cql
        cqlFromPage:'',//各个页面对应的cql

        nameDetail:'',//双击后保存的行政区名称
        pageHref:window.location.href,
        location: {},//定位跳转功能的Vector
        locationStyle: new Style({//定位点的样式
            image: new Icon({
                anchor: [0.5, 0],//设置图标偏移
                anchorOrigin: 'bottom-left',//标注样式的起点位置
                anchorXUnits: 'fraction', //X方向单位：分数
                anchorYUnits: 'pixels',//Y方向单位：像素
                // offsetOrigin: 'top-right',//偏移起点位置的方向
                opacity: 0.9,//透明度
                src: 'https://sj3upload.obs.cn-north-4.myhuaweicloud.com/imgs/%E5%AE%9A%E4%BD%8D%E8%B7%B3%E8%BD%AC.png',//图片路径
                scale: 0.2
            }),
        }),
        zoomLevel: '4',
        labelShow: true, 

        drawFinished:false,//是否绘制完成
        source: null,//勾绘和量测的图层source
        vector: null,//勾绘和量测的图层vector
        curMk:'',
        curTk: '',

        
        drawSelected:'绘制多边形',
        drawBtnShow:false,
        isUploadVector: false,
        isLeftVector: false,//是否左侧绘制矢量
        leftdrawFinished: false,//是否左侧绘制完成
        drawDisabled: false,  //左侧绘制时右侧按钮失效
        
        isSelectRegion: false,
        chinaProvinceNow: '',
        chinaCityNow: '',
        chinaCountyNow: '',
        chinaProvinceItems:[],
        chinaCityItems:[],
        chinaCountyItems:[],
        countryNow: '',
        countryItems: [],

        makeVectorName:false,   
        createSearchName: '',   
        uploadAndSelectVector: '',   


        //提示相关参数
        snackbar:false,
        snackbarColor:"",
        snackbarInfo:"",
        timeout: 3000,
        showCountyTip: false,


        overlay: false,

        showShootTime: false,//显示拍摄时间
        imagingTime: '',//拍摄时间


        printControl:{},//截图打印
        cutImgTitle: '',//截图打印

        
        juanlianBtnShow: false,//右侧卷帘工具按钮
        selectedMk:'',
        mapNumber:'',
        mapReviewNumber:'GS（2025）1834号',//地图审图号（对应2024年全国高质量一张图，iv:3ddec00f5f435270285ffc7ad1a60ce5，更改时需全局调整）
        mapReviewNumberAbroad:'GS吉(2023)010号', 
        idleTimeout: null,//地图无操作定时执行
        chinaJs: null,//中国地图js
        needEmit:false,//是否需要触发季新图事件
        str_wkt:null,
        str_area:null,//面积
        key_move: null,
        key_click: null,
        area_vector: new lVector(),

        baseMapTemplate: '',//图源包年底图模板，
       
        limit12Level: false,//是否流量耗尽
        show12LevelTip:false,
      }
    },
  methods: {
    resetIdleTimer(){
      if (this.idleTimeout) {
        clearTimeout(this.idleTimeout);
      }
      this.startIdleTimer();
    },
    startIdleTimer(){
      this.idleTimeout = setTimeout(() => {
        // 触发事件
        this.checkMapNumber();
      }, 3000);
    },
    checkMapNumber(){
      var center = toLonLat(this.map.getView().getCenter());
      let point = turf.point([center[0], center[1]]);
      let boolIntersect = false
      this.chinaJs.features.some(chnElement => {
        if (booleanContains(chnElement, point)) {
          boolIntersect = true
          return true
        }
      });
      if (boolIntersect) {
        this.mapNumber=this.mapReviewNumber
      } else {
        this.mapNumber=this.mapReviewNumberAbroad==null?this.mapReviewNumber:this.mapReviewNumberAbroad
      }
    },
    commonJuanLian() {
      bus.$emit('commonJuanLian',this.selectedMk)
    },
    changeDrawBtn(img) {
      this.isUploadVector = false
      this.isSelectRegion = false
      this.drawSelected=img
      this.drawBtnShow = false
      if (img=='绘制线矢量') {
        bus.$emit('distance')
      }  
      if (img=='绘制多边形') {
        bus.$emit('area')
      }  
      if (img == '上传矢量文件') {
        this.isUploadVector=true
      } 
      if (img == '行政区快选') {
        this.isSelectRegion=true
      } 
    },
    //左侧边栏绘制矢量工具
    vectorDraw(i) {
      this.isLeftVector = true
      this.isUploadVector = false
      this.isSelectRegion = false
      if (i == 1) {
        bus.$emit('area')
      }
      if (i == 2) { //后续改成矩形
        bus.$emit('rec')
      }
      if (i == 3) { //后续改成圆形
        bus.$emit('circle')
      }
      if (i == 4) {
        bus.$emit('distance')
      }
      if (i == 5) {
        this.isSelectRegion = true
      }
      if (i == 6) {
        this.isUploadVector = true
      }
    },
    addVectorSubmit(name) {
      let that=this

      this.overlay=true
      // 校验同名矢量
      let fd=new FormData()
      fd.append("name",name)
      this.axios.post("/map_service_back/vectorLibrary/checkNameValid",fd,{
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }).then(res => {
        this.overlay=false
        if (res.data.code==200&&res.data.message=='校验成功') {
          let formdata = new FormData()
          let geos=[];
          let pSet=new Set()  
          let features = this.source.getFeatures()
          features.forEach(f => {
            let fCloned=f.clone()
            let fClonedGeometry=fCloned.getGeometry()
            fClonedGeometry.transform(this.mapParams.projection, 'EPSG:4326')
            let type = f.getGeometry().getType()
            let coordinates,coorArr=[]
            if (type!='MultiPolygon') {
              coordinates = Array.from(fClonedGeometry.flatCoordinates)
              
              for (let i = 0; i < coordinates.length; i=i+2) {
                coorArr.push([coordinates[i],coordinates[i+1]])
              }
              console.log('coorArr',[coorArr])
            }
            if (type=='MultiPolygon') {
              // let polygon=turf.multiPolygon([[coorArr]])
              let polygon = JSON.parse(new GeoJSON().writeFeature(fCloned));//转为geojson
              geos.push(polygon);
            }
            if (type=='Polygon') {
              let polygon=turf.polygon([coorArr])
              geos.push(polygon);
            }
            if (type=='LineString') {
              let lineString=turf.lineString(coorArr)
              geos.push(lineString);
            }
            if (type == 'Circle') {
              var center = coorArr[0];
              var radius = coorArr[1][0]-coorArr[0][0];
              var options = { steps: 64, units: 'degrees' };
              var turfCircle = circle(center, radius, options);
              geos.push(turfCircle);
            }
          
            pSet.add(type)
          })
          if (Array.from(pSet).length>1) {
            this.$message.warning('不能同时加入多种类型图斑！')
            return
          }
          let myFeatures = []
          let geoType=''  
          geos.forEach(g => {
            let geo
            switch (g.geometry.type) {
              case 'Polygon':
                geo = new Polygon(g.geometry.coordinates)
                geoType= 'Polygon'
                break;
              case 'MultiPolygon':
                geo = new MultiPolygon(g.geometry.coordinates)
                geoType= 'MultiPolygon'
                break;
              case 'LineString':
                geo = new LineString(g.geometry.coordinates)
                geoType= 'LineString'
                break;
              // case 'MultiLineString':
                
              //   break;
            
              default:
                break;
            }
            let feature = new Feature({
              geometry: geo
            })
            myFeatures.push(feature)
          })

          let featureGeoJson,multi
          // if (geoType=='MultiPolygon') {
          //   myFeatures.forEach(f => {
          //     featureGeoJson = JSON.parse(new GeoJSON().writeFeature(f));//转为geojson
          //   })
          // } else {
            multi = GeometryToMulti(myFeatures,geoType)//转成多
            featureGeoJson = JSON.parse(new GeoJSON().writeFeature(multi));//转为geojson
          // }
          console.log(featureGeoJson);
					// debugger


          // let coorArrs=[]
          // myFeatures.forEach(f => {
          //   let coordinates = Array.from(f.getGeometry().flatCoordinates)
          //   let coorArr=[]
          //   for (let i = 0; i < coordinates.length; i=i+2) {
          //     coorArr.push([coordinates[i],coordinates[i+1]])
          //   }
          //   coorArrs.push(coorArr)
          // })
          // debugger
          // let unionGeo
          // if (type=='Polygon') {
          //   let polygon = turf.polygon(coorArrs)
          //   unionGeo=polygon  
          // }
          // if (type=='MultiPolygon') {
          //   let polygon = turf.multiPolygon([coorArrs])//turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
          //   unionGeo=polygon  
          // }
          // if (type=='MultiLineString') {
          //   let multiLineString = turf.multiLineString(coorArrs)
          //   unionGeo=multiLineString  
          // }
          // if (type=='LineString') {
          //   let lineString = turf.multiLineString(coorArrs)
          //   unionGeo=lineString  
          // }
          this.overlay=true
          if (this.uploadAndSelectVector) {//说明是上传的或者选择的省市县，直接用，免得4326和3857来回互转导致的精度bug，有可能会导致前后点经纬度不一致，形成未闭环bug
            formdata.append("geojson",JSON.stringify(this.uploadAndSelectVector))  
          } else {
            formdata.append("geojson",JSON.stringify(featureGeoJson.geometry))
          }
          formdata.append("name",name)
          this.axios.post("/map_service_back/vectorLibrary/insertVector",formdata,{
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }).then(res => {
            this.overlay=false
            if (res.data.code==200) {
              this.snackbar=true
              this.snackbarColor = '#ff9900'
              this.snackbarInfo = `创建成功！`
              this.makeVectorName = false
              that.$parent.$parent.getVectorLibrary()
            } else {
              this.snackbar=true
              this.snackbarColor = '#ff0000'
              this.snackbarInfo = `创建失败！`
              this.makeVectorName=false
            }
            this.createSearchName = ''
          })
          
        } else {
          this.snackbar=true
          this.snackbarColor = '#ff0000'
          this.snackbarInfo = `不可存在同名矢量，请更改名称！`
          this.createSearchName = ''
        }
      })

      
    },
    downloadShp() {
      // 获取全部的feature
      let features = this.source.getFeatures()
      // debugger
      let geos=[];
      let properties = [];
      let pSet=new Set()  
      features.forEach(f => {
        let fCloned=f.clone()
        let fClonedGeometry=fCloned.getGeometry()
        fClonedGeometry.transform(this.mapParams.projection, 'EPSG:4326')
        let type = f.getGeometry().getType()
        let coordinates,coorArr=[]
        if (type!='MultiPolygon') {
          coordinates = Array.from(fClonedGeometry.flatCoordinates)
          
          for (let i = 0; i < coordinates.length; i=i+2) {
            coorArr.push([coordinates[i],coordinates[i+1]])
          }
          console.log('coorArr',[coorArr])
        }
        let keys=Object.keys(f.values_)
        let values = Object.values(f.values_)
        let propertie = {}
        keys.forEach((v,index) => {
          if (v!='geometry') {
            propertie[v]=values[index]
          }  
        })    
        properties.push(propertie)
        if (type=='MultiPolygon') {
          // let polygon=turf.multiPolygon([[coorArr]])
          let polygon = JSON.parse(new GeoJSON().writeFeature(fCloned));//转为geojson
          // console.log(polygon);
          geos.push(polygon);
        }
        if (type=='Polygon') {
          let polygon=turf.polygon([coorArr])
          geos.push(polygon);
        }
        if (type=='LineString') {
          let lineString=turf.lineString(coorArr)
          geos.push(lineString);
        }
        pSet.add(type)
      })
      if (Array.from(pSet).length>1) {
        this.$message.warning('不能同时下载多种类型图斑！')
        return
      }

      this.overlay=true
      let wkts = geos.map(v => WKT.convert(v.geometry))
      console.log('wkts',wkts)
      this.axios({
          method:"post",
          url:'/koa_back/createShp',
          // url:'/accessapi/demandService/shapeOperation/generateShape',
          headers:{
              'Content-type':'application/json'
          },
          data:{wkts:wkts,name:'导出矢量',properties:JSON.stringify(properties)}
      })
        .then(res => {     
          this.overlay=false
          function downloadBase64File(base64Data, fileName) {
            const link = document.createElement('a');
            link.download = fileName;
            link.href = base64Data;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          downloadBase64File(res.data.result,'导出矢量.zip')
      })
    },
    triggerZoom(type) {
      let zoomIn=document.querySelector('.ol-zoom-in')
      let zoomOut=document.querySelector('.ol-zoom-out')
      if (type==1) {
        zoomIn.click()
      } else {
        zoomOut.click()  
      }
      this.zoomLevel=Math.round(this.map.getView().getZoom())
    },
      /**
       * @Author: qhy
       * @Date: 2022-05-20 12:38:04
       * @LastEditors: qhy
       * @Description: 定位到p点
       * @param p
       * @return {*}
       */
      jumpTo(p) {
          this.location.clear();
          let f = new Feature ({
              type: 'icon',
              geometry: new Point(p),
          });
          f.setStyle (this.locationStyle);
          this.location.addFeature(f);
          
          this.map.getView().animate({
              center: p,
              zoom: Math.max(this.map.getView().getZoom(), 12)
          });
      },
      showLabel(){
        let allLayers = this.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
        allLayers.forEach(layer => {
          if (layer.values_.title=='天地图注记') {
            layer.setVisible(!layer.getVisible())
          }
        })
        this.labelShow = !this.labelShow
        // debugger
      },
      //新增对话框
      handleAdd: function() {
        this.$refs.modalForm.add()
        this.$refs.modalForm.title = '新增'
        this.$refs.modalForm.disableSubmit = false
      },
      //透明度调节
      handleOpt() {
        document.body.classList.toggle('hideOpacity')
        document.body.classList.toggle('hidePercent')
      },
      //显示/隐藏全部图层
      handleAllLayers() {
        if (this.allHide) {
          this.map.getLayers().forEach(layer=>{
            if (layer instanceof Group&&layer.values_.title!=='天地图服务') {
              layer.values_.layers.forEach(l=>{
                l.setVisible(true);
              })
            }
            if (!(layer instanceof Group&&layer.values_.title==='天地图服务')) {
              layer.setVisible(true);
              this.addLegend(layer);
              this.addToModelist(layer, "juanlianList1");
              this.addToModelist(layer, "juanlianList2");
            }
          })
          this.allHide=false;
        }else{
          this.map.getLayers().forEach(layer=>{
            if (!(layer instanceof Group&&layer.values_.title==='天地图服务')) {
              layer.setVisible(false)
              this.deleteLegend(layer);
              this.deleteFromModelist(layer,"juanlianList1");//从卷帘面板列表中删除
              this.deleteFromModelist(layer,"juanlianList2");//从卷帘面板列表中删除
            }
            if (layer instanceof Group&&layer.values_.title!=='天地图服务') {
              layer.values_.layers.forEach(l=>{
                l.setVisible(false);
              })
            }
          })
          this.allHide=true;
        }
      },
      //地图左上角-功能启动图标按钮-初始化控制
      initMapCtrlTools() {
        if (this.mapCtrlTools !== undefined && this.mapCtrlTools.length > 0) {
          this.mapCtrlTools.forEach(item => {
            if (item === 1) {
              this.lyrsBtnShow = true //图层管理控制-功能启动图标按钮
            } else if (item === 2) {
              this.measureBtnShow = true //测量工具-功能菜单启动图标按钮
            } else if (item === 3) {
              this.decorateBtnShow = true //地图整饰-功能菜单启动图标按钮
            } else if (item === 4) {
              this.juanlianShow = true //卷帘-功能菜单启动图标按钮
            } else if (item === 5) {
              this.dataPanel = true //打开/关闭数据面板-功能菜单启动图标按钮
            } else if (item === 6) {
              this.legendBtnShow = true //图例数据面板-功能菜单启动图标按钮
            } else if (item === 7) {
              this.lyrPanal = true //首页的复选框面板-功能菜单启动图标按钮
            } else if (item === 8) {
              this.blingblingBtn = true //首页的触发闪烁功能的按钮-功能菜单启动图标按钮
            }
          })
        }
      },
      triggerDistance() {
        this.isMeasure = true
        this.measurePanelVisible = false
        this.drawBtnShow = false
        this.drawFinished = false
        bus.$emit('distance')
      },
      triggerArea() {
        this.isMeasure = true
        this.measurePanelVisible = false
        this.drawBtnShow = false
        this.drawFinished = false
        bus.$emit('area')
      },
      triggerClean() {
        this.isMeasure = false
        this.measurePanelVisible = false;
        this.drawBtnShow = false;

        this.drawSelected = '绘制多边形';
        this.isSelectRegion = false;
        this.uploadAndSelectVector = ''

        bus.$emit('clean')
      },
      triggerLayerSwitcher() {
        let dis = document.querySelector('#' + this.lyrBox).style.display;
        document.querySelector('#' + this.lyrBox).style.display = dis != 'block' ? 'block' : 'none'
      },

      //卷帘相关函数
      togglePanel(...attrs){
        attrs.forEach(attr=>{
          this[attr] = !this[attr];
        })
      },
      toggleJL(titleLeftOrUp,titleRightOrDown){
        // let canvas=document.querySelector('canvas');
        if (this.flagJL) {
          this.swipe = new Swipe();
          this.swipe.setMap(this.map);
          this.map.addControl(this.swipe);
          let allLayers=this.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
          allLayers.forEach(layer => {
              if (titleLeftOrUp==layer.values_.title) {
                  this.JLLeftlyr=layer
                  layer.setVisible(true)
              }
              if (titleRightOrDown==layer.values_.title) {
                  this.JLRightlyr=layer
                  layer.setVisible(true)
              }
          })
          this.swipe.set('orientation','vertical');
          this.swipe.addLayer(this.JLLeftlyr);//左侧
          this.swipe.addLayer(this.JLRightlyr, true);//右侧
          
        }else{
          this.map.removeControl(this.swipe);
        }

        this.flagJL = !this.flagJL;
      },
      // toggleJL(){
      //   let that=this;
      //   let canvas=document.querySelector('canvas');
      //   let juanlianButton=document.getElementById('juanlianButton');

      //   if (this.flagJL) {
      //     let titleLeftOrUp=document.getElementById('juanlianList1').value;
      //     let titleRightOrDown=document.getElementById('juanlianList2').value;
      //     if (titleLeftOrUp===titleRightOrDown) {
      //       this.$message.warning('卷帘对比两侧不可相同！')
      //       return;
      //     }

      //     juanlianButton.value="停止控制"
      //     canvas.removeAttribute("style");//移除canvas原始的样式，在开始卷帘时需要删除，否则样式会乱，卷帘结束再设置回去
      //     this.swipe = new Swipe();
      //     this.swipe.setMap(this.map);
      //     this.map.addControl(this.swipe);
      //     let verticalswipe=document.getElementById('verticalswipe').checked;
      //     let horizontalswipe=document.getElementById('horizontalswipe').checked;

      //     let lyrs=[];
      //     this.map.getLayers().forEach(layer=>{
      //       if (layer instanceof Group) {
      //         if (layer.values_.title!=="天地图服务") {
      //           layer.values_.layers.forEach(l=>{
      //             if (l.values_.title===titleLeftOrUp) {
      //               lyrs[0]=l;
      //             }else if (l.values_.title===titleRightOrDown) {
      //               lyrs[1]=l;
      //             }else {
      //               if (l.values_.visible) {
      //                 that.notJLLayers.push(l);
      //                 l.values_.visible=false;
      //               }
      //             }
      //           })
      //         }
      //       } else {
      //         if (layer.values_.title===titleLeftOrUp) {
      //           lyrs[0]=layer;
      //         }else if (layer.values_.title===titleRightOrDown) {
      //           lyrs[1]=layer;
      //         }else {
      //           if (layer.values_.visible) {
      //             that.notJLLayers.push(layer);
      //             layer.values_.visible=false;
      //           }
      //         }
      //       }

      //     })
      //     if (verticalswipe) {//垂直方向
      //       this.swipe.set('orientation','vertical');
      //       this.swipe.addLayer(lyrs[0]);//左侧
      //       this.swipe.addLayer(lyrs[1], true);//右侧
      //     }
      //     if (horizontalswipe) {//水平方向
      //       this.swipe.set('orientation','horizontal');
      //       this.swipe.addLayer(lyrs[0]);//上侧
      //       this.swipe.addLayer(lyrs[1], true);//下侧
      //     }
      //   }else{
      //     that.notJLLayers.forEach(layer=>{
      //       layer.values_.visible=true;
      //     })
      //     this.map.removeControl(this.swipe);
      //     canvas.style="width: 100%; height: 100%; display: block;";//这是canvas原始的样式，在开始卷帘时需要删除，否则样式会乱，卷帘结束再设置回去
      //     juanlianButton.value="开始控制"

      //   }

      //   this.flagJL = !this.flagJL;
      // },

      addLyrListToJuanlianPanel(){
        let that=this;
        document.getElementById("juanlianList1").options.length = 0;   //卷帘控制-底衬层（底图图层）
        document.getElementById("juanlianList2").options.length = 0;   //卷帘控制-卷帘层（底图图层）
        this.map.getLayers().forEach(layer=>{
          // if (layer instanceof Group) {//图层组单独把每一个图层拿出来
          //   layer.values_.layers.forEach(l=>{
          //     if ((!(l.getSource() instanceof Cluster))&&l.values_.visible) {//去掉集群图层和不显示的图层
          //       // if ((!(l.getSource() instanceof Cluster))) {//去掉集群图层
          //       that.addToModelist(l, "juanlianList1");
          //       that.addToModelist(l, "juanlianList2");
          //     }
          //   })
          // } else {
          //   if ((!(layer.getSource() instanceof Cluster)&&layer.values_.visible)) {//去掉集群图层和不显示的图层
          //     // if ((!(layer.getSource() instanceof Cluster))) {//去掉集群图层
          //     that.addToModelist(layer, "juanlianList1");
          //     that.addToModelist(layer, "juanlianList2");
          //   }
          // }
          that.addToModelist(layer, "juanlianList1");
          that.addToModelist(layer, "juanlianList2");
        })
      },
      addToModelist(layer, divName) {
        let selectObject = document.getElementById(divName);
        if (layer instanceof Group) {//图层组单独把每一个图层拿出来
          if (layer.values_.title!=="天地图服务") {
            layer.values_.layers.forEach(l=>{
              if ((!(l.getSource() instanceof Cluster))&&l.values_.visible&&(!(l.values_.title=="路网"||l.values_.title=="卫星"))) {//去掉集群图层和不显示的图层
                for(let i=0;i<selectObject.options.length;i++){
                  if (selectObject.options[i].value===l.values_.title) {
                    return;//如果已经有了就不添加了
                  }
                }
                let optionObject = new Option(l.values_.title, l.values_.title);
                selectObject.options[selectObject.options.length] = optionObject;
              }
            })
          }
        } else {
          if ((!(layer.getSource() instanceof Cluster))&&layer.values_.visible&&(!(layer.values_.title=="路网"||layer.values_.title=="卫星"))) {//去掉集群图层和不显示的图层
            for(let i=0;i<selectObject.options.length;i++){
              if (selectObject.options[i].value===layer.values_.title) {
                return;//如果已经有了就不添加了
              }
            }
            let optionObject = new Option(layer.values_.title, layer.values_.title);
            selectObject.options[selectObject.options.length] = optionObject;
          }
        }

      },
      deleteFromModelist(layer, divName) {
        let selectObject = document.getElementById(divName);
        if (layer instanceof Group) {
          layer.values_.layers.forEach(l=>{
            for(let i=0;i<selectObject.options.length;i++){
              if (selectObject.options[i].value===l.values_.title) {
                selectObject.options[i]=null;//删除
              }
            }
          })
        }else{
          for(let i=0;i<selectObject.options.length;i++){
            if (selectObject.options[i].value===layer.values_.title) {
              selectObject.options[i]=null;//删除
            }
          }
        }
      },

      // getLyrServices() {
      //   function Layer(value) {
      //     switch (value.serviceType) {
      //     case 'VectorLayer': {
      //       this.lyrType = 'lVector'
      //       break
      //     }
      //     case 'ImageLayer': {
      //       this.lyrType = 'Image'
      //       break
      //     }
      //     case 'TileLayer': {
      //       this.lyrType = 'Tile'
      //       break
      //     }
      //     default: {
      //       console.error('遇到其他类型服务，目前代码还没写。。')
      //       break
      //     }
      //     }

      //     switch (value.layerSource) {
      //     case 'VectorSource': {
      //       this.srcType = 'Vector'
      //       break
      //     }
      //     case 'VectorSourceCluster': {
      //       this.srcType = 'Cluster'
      //       break
      //     }
      //     case 'TileWMS': {
      //       this.srcType = 'TileWMS'
      //       break
      //     }
      //     case 'ImageWMS': {
      //       this.srcType = 'ImageWMS'
      //       break
      //     }
      //     case 'XYZ': {
      //       this.srcType = 'XYZ'
      //       break
      //     }
      //     case 'ImageArcGISRest': {
      //       this.srcType = 'ImageArcGISRest'
      //       break
      //     }
      //     case 'TileArcGISRest': {
      //       this.srcType = 'TileArcGISRest'
      //       break
      //     }
      //     case 'OSM': {
      //       this.srcType = 'OSM'
      //       break
      //     }
      //     default: {
      //       console.error('遇到其他类型服务，目前代码还没写。。')
      //       break
      //     }
      //     }
      //     this.mUrl = value.productUrl;
      //     this.mTitle = value.productName;
      //     this.mName = value.productName;
      //     this.mVisible = true;
      //     this.mKey=value.key;
      //   }

      //   httpAction('/rsService/rsService/listAll', null, 'get').then(
      //     function(res) {
      //       if (res.success) {
      //         let mapDataTemp = []
      //         // console.log(res.result, 'res.result')
      //         // console.log(this.mapServiceDist, '此处的this.mapServiceDist')
      //         for (let i = 0; i < res.result.length; i++) {
      //           res.result[i].menu.forEach(value => {
      //             if (value.menu === this.mapServiceDist) {
      //               let tempObject = new Layer(res.result[i])
      //               mapDataTemp.push(tempObject)
      //             }
      //           })
      //         }
      //         this.mapLayersToShow = mapDataTemp
      //         this.loadGisMap()
      //       } else {
      //         this.$message.warning(res.message)
      //       }
      //     }.bind(this)
      //   )
      // },
      printScreen() {
        html2canvas(document.getElementById('map'), {
          scale: 2,//提高分辨率
          useCORS: true,
          allowTaint: false,
          ignoreElements: (element) => {//获取cdn下的元素超时，忽略掉
            if (element.href==='https://cdn.jsdelivr.net/npm/@fontsource/din-pro/700.css'||element.href==='https://cdn.jsdelivr.net/npm/@fontsource/din-pro/400.css') {
              return true
            }
          },
        })
        .then(canvas => {
          const dataUrl = canvas.toDataURL("image/jpeg");
          bus.$emit('cutImageFinished',dataUrl)
        })
    },
      async loadGisMap() {
        let that = this
        let lyrdata = this.lyrdata
        let area //面积定义为全局变量，便于弹出的窗口获取到绘制图形的面积
        let wkt
        let j1,
          j2,
          listener = null

        let mapCenter=this.mapParams.center;
        mapCenter=fromLonLat(mapCenter);

        //region View和Map
        var view = new View({
          projection: this.mapParams.projection, //例如：'EPSG:4326', //发布的影像原始坐标系为4326，必须加上此投影才能显示发布的影像
          center: mapCenter, //例如：[127.87535, 43.58279] 或 [126.47535, 43.58279],//地图初始中心点
          minZoom: this.mapParams.minZoom, //例如：5，//可以缩小的最小级别;若为undefined表示无限制
          maxZoom: this.mapParams.maxZoom, //例如：19，//可以放大的最大级别；若为undefined表示无限制
          zoom: this.mapParams.zoom, //例如：6，//地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
          constrainResolution:true,
          smoothResolutionConstraint:false,
        })

        //实例化Map对象加载地图
        var map = new Map({
          // controls: defaults({ zoom: false,rotate:false }), //默认不显示缩放控件
          controls: defaults({ rotate:false }), //默认不显示缩放控件
          target: 'map', //地图容器div的ID
          layers: [], //例如：tiandituLayersGroup,osmLayer,vector1
          view: view
        })
        //endregion View和Map

        this.map = map;
        var tiandituSatelliteLabel = new Tile({
          title: '天地图注记',
          source: new XYZ({
            url: 'http://t{0-7}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d',
            crossOrigin: 'anonymous',
            maxZoom: 18,
            minZoom: 0,
          }),
          visible: true,
          zIndex: 1
        })
        map.addLayer(tiandituSatelliteLabel)

        //region 比例尺、坐标控件
        //比例尺控件
        var scaleLineControl = new ScaleLine({
          units: 'metric',
          target: 'scaleBar',
          className: 'ol-scale-line'
        })

        //坐标
        var mousePositionControl = new MousePosition({
          // coordinateFormat: createStringXY(5), //坐标小数位数
          coordinateFormat: (coordinate) => {
            // 显示gcj02火星坐标系
            let gcj02Coordinate=coordtransform.wgs84togcj02(coordinate[0],coordinate[1])
            return formatCoordinate(gcj02Coordinate, '{x}, {y}', 2);
          },
          className: 'custom-mouse-position',
          target: document.getElementById('mouse-position'),
          undefinedHTML: '&nbsp;',
          projection:'EPSG:4326'
        })

        this.chinaJs = JSON.parse(china)
        map.on('moveend', function () {
          that.resetIdleTimer()
        })
        // var mousePositionControl1 = new MousePosition({
        //   // coordinateFormat: createStringXY(5), //坐标小数位数
        //   coordinateFormat: async (coordinate) => {
        //     // await this.axios.get(`/map_service_back/getTileInfo/${that.zoomLevel}/${coordinate[0]}/${coordinate[1]}?mk=${that.curMk}&tk=${that.curTk}`).then(res => {
        //     await this.axios.get(`/map_service_back/getTileInfo/${that.zoomLevel}/${coordinate[0]}/${coordinate[1]}?mk=f9b7b0f6aa2bf015e23b131e537ea9a9&tk=${that.curTk}`).then(res => {
        //       if (res.data.code==200) {
        //         // console.log(res.data.data)
        //         let data=res.data.data[0]
        //         let features=data.features?data.features:[data]
        //         features.forEach((f,index) => {
        //           let archiveTime = f.properties.archiveTime
        //           let imagingTime = f.properties.imagingTime.replace(/ .*/,'')
        //           console.log(index,imagingTime)
        //         })
        //       } 
        //       Promise.resolve() //如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
        //     }).catch(function(error) {
        //       console.log(error)
        //     }) 
        //   },
        //   className: 'custom-mouse-position',
        //   target: document.getElementById('shootDate'),
        //   undefinedHTML: '&nbsp;',
        //   projection:'EPSG:4326'
        // })
        if (this.showTools&&this.showBottomBar) {
          //将比例尺控件添加到地图容器中
          map.addControl(scaleLineControl)
          //将坐标控件添加到地图容器中
          map.addControl(mousePositionControl)
          // map.addControl(mousePositionControl1)
        }
        //endregion

        // 打印地图控件
        let printControl = new Print();
        map.addControl(printControl);
        that.printControl=printControl;

        /* On print > save image file */
        printControl.on('printing', function(e) {
          // $('body').css('opacity', .5);
          // document.querySelector('body')
        });
        printControl.on(['print', 'error'], function(e) {
          // Print success
          
          if (e.image) {
            // if (e.pdf) {
            //   // Export pdf using the print info
            //   var pdf = new jsPDF({
            //     orientation: e.print.orientation,
            //     unit: e.print.unit,
            //     format: e.print.format
            //   });
            //   pdf.addImage(e.image, 'JPEG', e.print.position[0], e.print.position[0], e.print.imageWidth, e.print.imageHeight);
            //   pdf.save(that.cutImgTitle);
            // } else  {
            console.log('e.image',e.image)
            bus.$emit('cutImageFinished',e.image)

            // return e.image;

              // e.canvas.toBlob(function(blob) {
              //   saveAs(blob, `地图.`+e.imageType.replace('image/',''));
              //   // console.log('blob',blob)
              //   // debugger
              // }, e.imageType);

            //   // document.querySelector('#image img').setAttribute('src',e.image)
            // }
          } else {
            console.warn('No canvas to export');
          }
        });

        //region 循环调用addLyr4init()方法把lyrdata解析出来（保留图层组合结构）
        lyrdata = [...lyrdata, ...this.mapLayersToShow] //除了myconf.js配置的图层外加入发布的图层

        this.baseMap = []
        for (let i = 0, len = lyrdata.length; i < len; i++) {

          let tmpLyrs = await addLyr4init(
            lyrdata[i].lyrType,
            lyrdata[i].srcType,
            lyrdata[i].mUrl,
            lyrdata[i].mTitle,
            lyrdata[i].mName,
            lyrdata[i].mVisible,
            lyrdata[i].mExtent,
            lyrdata[i].mSubLayers,
            lyrdata[i].mKey,
            lyrdata[i].sk,
            lyrdata[i].mType,
          )
          // tmpLyrs.then(v=>{
          //   v.forEach(value => {
          //     this.baseMap.push(value)
          //     map.addLayer(value)
          //   })
          // })
          tmpLyrs.forEach(value => {
            this.baseMap.push(value)
            map.addLayer(value)
            
            //添加图例
            if (value instanceof Group && value.values_.title=="矢量图层") {
              that.addLegend(value);
            }

          })
        }
        // if (lyrdata[1].mExtent&&lyrdata[1].mExtent.length>0) {
          // let ext=this.changeBboxFromLonLat(lyrdata[1].mExtent)
          // map.getView().fit(ext)
          this.zoomLevel=map.getView().getZoom()
        // }


        bus.$off('refreshMap');//先解绑再绑定，避免绑定的事件被多次触发
        bus.$on('refreshMap', layers => {
          layers.forEach(data=>{
            if (that.checkedMapKey.includes(data.mKey)) {
              let lyr={}
              map.getLayers().forEach(layer => {
                if (layer.values_.key===data.mKey) {
                  lyr=layer;
                }
              })
              map.removeLayer(lyr);//删除图层
              that.deleteLegend(lyr);
              that.deleteFromModelist(lyr,"juanlianList1");//从卷帘面板列表中删除
              that.deleteFromModelist(lyr,"juanlianList2");//从卷帘面板列表中删除

              that.checkedMapKey=that.checkedMapKey.filter(v=>{
                return v!=data.mKey;
              })
            }else{
              let tmpLyrs = addLyr4init(
                data.lyrType,
                data.srcType,
                data.mUrl,
                data.mTitle,
                data.mName,
                data.mVisible,
                data.mExtent,
                data.mSubLayers,
                data.mKey,
                data.sk,
                data.mType,
              )
              tmpLyrs.then(v=>{
                v.forEach(value => {
                  map.addLayer(value)
                  if (!(value.getSource() instanceof Vector||value.getSource() instanceof Cluster)) {//这里等处理完这俩类型之后再改
                    map.getView().fit(value.getSource().params_.BBOX)//缩放至
                  }
                  that.addLegend(value);
                  if (!(value.getSource() instanceof Cluster)) {//向卷帘里面加且去掉集群图层
                    that.addToModelist(value, "juanlianList1");
                    that.addToModelist(value, "juanlianList2");
                  }
                })
              });
              that.checkedMapKey.push(data.mKey);
            }
          })

        })
        //endregion

        //region 【方法】初始化添加图层
        async function addLyr4init(lyrType, srcType, mUrl, mTitle, mName, mVisible, mExtent, mSubLayers,mKey,sk,mType) {
          //以下部分用于设置集群的样式及半径大小的计算
          let maxFeatureCount
          let calculateClusterInfo = function(resolution) {
            maxFeatureCount = 0
            let features = lyr.getSource().getFeatures()
            let feature, radius
            for (let i = features.length - 1; i >= 0; --i) {
              feature = features[i]
              let originalFeatures = feature.get('features')
              let extent = createEmpty()
              let j = void 0,
                jj = void 0
              for (j = 0, jj = originalFeatures.length; j < jj; ++j) {
                extend(extent, originalFeatures[j].getGeometry().getExtent())
              }
              maxFeatureCount = Math.max(maxFeatureCount, jj)
              /* radius = 0.025 * (getWidth(extent) + getHeight(extent)) /
                  resolution; */
              feature.set('radius', 1)
            }
          }

          let currentResolution
          function styleFunction(feature, resolution) {
            if (resolution != currentResolution) {
              calculateClusterInfo(resolution)
              currentResolution = resolution
            }
            let style
            if (feature.get('features')) {
              let size = feature.get('features').length
              if (size >= 1) {
                style = new Style({
                  image: new CircleStyle({
                    radius: feature.get('radius'),
                    fill: new Fill({
                      color: [255, 153, 0, Math.min(0.8, 0.4 + size / maxFeatureCount)]
                    })
                  }),
                  text: new Text({
                    text: size.toString(),
                    fill: new Fill({
                      color: '#fff'
                    }),
                    stroke: new Stroke({
                      color: 'rgba(0, 0, 0, 0.6)',
                      width: 3
                    }),
                    font: '20px sans-serif'
                  })
                })
              } else {
                // var originalFeature = feature.get('features')[0];
                // style = createEarthquakeStyle(originalFeature);
                style = null //没啥用
              }
            }
            return style
          }
          //以上部分用于设置集群的样式及半径大小的计算
          // function vectorStyle(feature, resolution) {
          //   let style = new Style({
          //     fill: new Fill({
          //       color: 'rgba(255, 255, 255, 0)' //填充颜色
          //     }),
          //     stroke: new Stroke({
          //       color: 'red', //边框颜色
          //       width: 2 // 边框宽度
          //     }),
          //   })

          //   return style
          // }

          function vectorLoader(extent, resolution, projection) {
            let this1=this;
            var proj = projection.getCode()
            var url = mUrl
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url)
            var onError = function() {
              this1.removeLoadedExtent(extent)
            }
            xhr.onerror = onError
            xhr.onload = function() {
              if (xhr.status == 200) {
                let features = this1.getFormat().readFeatures(xhr.responseText)
                if (that.taskStatus.length!=0) {//这种方式不好，应该直接从服务中过滤，待改！
                  features=features.filter(feature=>{
                    if (that.taskStatus.includes(feature.values_.status)) {
                      return true;
                    }
                    return false;
                  })
                }
                // features=features.filter(feature=>{
                //   if (this1.url_===feature.values_.time) {
                //     return true;
                //   }
                //   return false;
                // })
                this1.addFeatures(features)
              } else {
                onError()
              }
            }
            xhr.send()
          }



          //以下部分用于获取服务中的extent属性以及图例，不同服务有不同的获取方式，需要详细考虑
          let ext=[];
          let layersForLegend=[];
          let resolutions=[];
          let times=new Set();
          if (/geoserver/.test(mUrl)) {
            let parser = new WMSCapabilities();
            // let parser = new WMSGetFeatureInfo();
            let name='';
            // let tempURL = mUrl+'&request=GetCapabilities';
            let tURL = mUrl;
            let tempURL = mUrl;
            if (/GetFeature/i.test(tURL)) {//暂时没解决
              // tURL=tURL.replace(/GetFeature/,'GetCapabilities');
              tURL.split("?")[1].split("&").forEach(value=>{
                if (/(LAYERS|typeName)=.+?/.test(value)) {
                  name= value;
                }
              })
              name=name.split("=")[1];
              // that.featureTypesForAttr.push(name);
              // if (name) {
              //   await that.$axios({url: tURL}).then(function(response) {
              //     let result = parser.read(response.data);
              //     console.log(response.data)
              //     console.log(result);
              //     result.FeatureTypeList.FeatureType.forEach(layer=>{
              //       if (layer.Title===name) {
              //         ext=[layer.LatLongBoundingBox.minx,layer.LatLongBoundingBox.miny,layer.LatLongBoundingBox.maxx,layer.LatLongBoundingBox.maxy];
              //         console.log(ext);
              //       }
              //     })
              //     Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
              //   })
              //   .catch(function(error) {
              //     console.log(error)
              //   })
              // }

              await that.$axios({url: tURL}).then(function(response) {
                let features = new GeoJSON().readFeatures(response.data)
                features.forEach(f=>{
                  times.add(f.values_.time);
                })
                times=Array.from(times).sort();//排序
                // times=Array.from(times);
                Promise.resolve();//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
              }).catch(function(error) {
                  console.log(error)
                })
            }else if (/GetMap/i.test(tURL)) {
              tURL=tURL.replace(/GetMap/,'GetCapabilities');
              tURL.split("?")[1].split("&").forEach(value=>{
                if (/(LAYERS|typeName)=.+?/i.test(value)) {
                  name= value;
                }
              })
              name=name.split("=")[1];
              that.featureTypesForAttr.push(name);
              name=name.split(":")[1];
              if (name) {
                let stylesForLegend=[];
                await that.$axios({url: tURL}).then(function(response) {
                  let result = parser.read(response.data);
                  // console.log(result);
                  result.Capability.Layer.Layer.forEach(layer=>{
                    if (layer.Name===name) {
                      ext=layer.EX_GeographicBoundingBox;//可能为undefined
                      if (!ext) {
                        ext=layer.BoundingBox[0].extent;
                      }
                      // layer.Style.forEach(style=>{
                      //   let legendURLs=style.LegendURL;
                      //   legendURLs.forEach(leg=>{
                      //     layersForLegend.push(leg);
                      //   })
                      // })
                    }
                  })
                  Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                })
                  .catch(function(error) {
                    console.log(error)
                  })
              }
            }else if (/tms/i.test(tURL)) {
              let layerName=tURL.split('/');
              layerName=layerName[layerName.length-1].split('@')[0];
              let ws=layerName.split('%')[0];
              let getCapabilitiesUrl=`${tURL.split('gwc')[0]+ws}/wms?service=WMS&version=1.1.0&request=GetCapabilities&layers=${layerName}&styles=`;

              name=layerName;
              // that.featureTypesForAttr.push(name);
              name=name.split("%3A")[1];
              if (name) {
                let stylesForLegend=[];
                await that.$axios({url: getCapabilitiesUrl}).then(function(response) {
                  let result = parser.read(response.data);
                  // console.log(result);
                  result.Capability.Layer.Layer.forEach(layer=>{
                    if (layer.Name===name) {
                      ext=layer.EX_GeographicBoundingBox;//可能为undefined
                      if (!ext) {
                        if (Math.abs(layer.BoundingBox[0].extent[0]-124)<100) {//待改
                          ext=layer.BoundingBox[0].extent;
                        }
                      }
                      if (layer.Name!='JiLinShp') {
                        layer.Style.forEach(style=>{
                          let legendURLs=style.LegendURL;
                          legendURLs.forEach(leg=>{
                            layersForLegend.push(leg);
                          })
                        })
                      }
                    }
                  })
                  Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                })
                .catch(function(error) {
                  console.log(error)
                })
              }
              let parserForTMS=new DOMParser(); //解析xml或者html
              await that.$axios({url: tURL}).then(function(response) {
                let xmlDoc=parserForTMS.parseFromString(response.data,"text/xml"); //解析xml或者html
                //提取数据
                let box = xmlDoc.getElementsByTagName('BoundingBox');
                let attr=box[0].attributes;
                ext=[Number(attr[0].value),Number(attr[1].value),Number(attr[2].value),Number(attr[3].value)];
                // console.log(ext);
                let tileSets = xmlDoc.getElementsByTagName('TileSets')[0].children;
                for (const t of tileSets) {
                  resolutions.push(t.attributes['units-per-pixel'].nodeValue);
                }
              })
              .catch(function(error) {
                console.log(error)
              })
            }else{
              tempURL+='&request=GetCapabilities';
              tempURL.split("?")[1].split("&").forEach(value=>{
                if (/(LAYERS|typeName)=.+?/i.test(value)) {
                  name= value;
                }
              })
              name=name.split(":")[1];
              // let reg=/(LAYERS|typeName)=.+?&/.exec(tempURL);//?非贪婪模式匹配最少字符
              // console.log(reg);
              if (name) {
                let stylesForLegend=[];
                await that.$axios({url: tempURL}).then(function(response) {
                  let result = parser.read(response.data);
                  // console.log(result);
                  result.Capability.Layer.Layer.forEach(layer=>{
                    if (layer.Name===name) {
                      ext=layer.EX_GeographicBoundingBox;//可能为undefined
                      if (!ext) {
                        ext=layer.BoundingBox[0].extent;
                      }
                      layer.Style.forEach(style=>{
                        let legendURLs=style.LegendURL;
                        legendURLs.forEach(leg=>{
                          layersForLegend.push(leg);
                        })
                      })
                    }
                  })
                  Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                })
                  .catch(function(error) {
                    console.log(error)
                  })
              }
            }
          }else if (/arcgis/.test(mUrl)) {
            let tempURL = mUrl+'?f=json';
            await that.$axios({url: tempURL}).then(function(response) {
              let fExt=response.data.fullExtent;
              ext=[fExt.xmin,fExt.ymin,fExt.xmax,fExt.ymax]
              Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
            })
              .catch(function(error) {
                console.log(error)
              })

            tempURL = mUrl+'/legend?f=json';
            await that.$axios({url: tempURL}).then(function(response) {
              // console.log(response.data)
              layersForLegend=response.data;
              Promise.resolve();//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
            })
              .catch(function(error) {
                console.log(error)
              })
          }
          //以上部分用于获取服务中的extent属性以及图例，不同服务有不同的获取方式，需要详细考虑

          let lyrArr = []
          let lyr = null
          if (lyrType === 'Image' && srcType === 'TileWMS') {
            lyr = new Image({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              source: new TileWMS({
                url: mUrl,
                params:{
                  BBOX:ext
                }
              })
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'Image' && srcType === 'ImageArcGISRest') {
            lyr = new Image({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              layersForLegend:layersForLegend,
              source: new ImageArcGISRest({
                url: mUrl,
                params:{
                  BBOX:ext
                }
              })
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'Image' && srcType === 'ImageWMS') {
            let cql=null;
            // debugger
            if (that.departname.length==1&&/解译/.test(mTitle)) {
              let keyName='';
              if (/^市/.test(that.departname[0])||!/[区市山县]/.test(that.departname[0])) keyName='depart';
              else keyName='cou';
              cql=`${keyName} like '%${that.departname[0]}%'`;
            }
            if (that.departname.length==2&&/解译/.test(mTitle)) {
              cql=`cou like '%${that.departname[0]}%'&&depart like '%${that.departname[1]}%'`;
            }

            if (/解译/.test(mTitle)&&that.cqlFromPage!=''&&that.cqlFromPage!=null) {//加上各页面的查询条件
              if (cql==null) cql=that.cqlFromPage;
              else cql+=` and ${that.cqlFromPage}`
            }

            lyr = new Image({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              layersForLegend:layersForLegend,
              source: new ImageWMS({
                crossOrigin:'anonymous',
                url: mUrl,
                params:{
                  BBOX:ext,
                  'CQL_FILTER':cql
                }
              })
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'Tile' && srcType === 'TileArcGISRest') {
            lyr = new Tile({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              layersForLegend:layersForLegend,
              source: new TileArcGISRest({
                url: mUrl,
                params:{
                  BBOX:ext
                }
              })
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'Tile' && srcType === 'TileWMS') {
            lyr = new Tile({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              layersForLegend:layersForLegend,
              source: new TileWMS({
                url: mUrl,
                params:{
                  BBOX:ext
                }
              })
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'Tile' && srcType === 'XYZ') {
            let display=true;
            if(mTitle==="路网"||mTitle==="卫星"||mTitle==="文字标注"){
              lyr = new Tile({
                title: mTitle,
                name: mName,
                visible: mVisible,
                key:mKey,
                displayInLayerSwitcher: display, //在图层面板中不显示
                source: new XYZ({
                  url: mUrl,
                  params:{
                    BBOX:ext
                  }
                })
              })
            }else{
              let source={};
              if (/(charmingglobe)|(tile)|(getMap)/.test(mUrl)) {//一室那边给的url（需要提前将数字改成/{z}/{x}/{-y}）
                if(mTitle=='2023年度全国高质量一张图'){
                  source = new XYZ({
                    crossOrigin: 'anonymous',
                    projection: 'EPSG:3857',
                    maxZoom: 19,
                    minZoom: 0,
                    url: mUrl,
                  })
                }
                else{
                  source = new XYZ({
                    crossOrigin: 'anonymous',
                    projection: 'EPSG:3857',
                    maxZoom: 18,
                    minZoom: 0,
                    url: mUrl,
                  })
                }
              }else if (/getTile/.test(mUrl)) {//流量包地图
                // that.baseMapTemplate = mUrl
                source = new XYZ({
                  crossOrigin: 'anonymous',
                  projection: 'EPSG:3857',
                  maxZoom: 18,
                  minZoom: 0,
                  // url: mUrl,
                  tileUrlFunction(tileCoord, pixelRatio, proj) {
                    const [z, x, y] = tileCoord
                    let y_ = Math.pow(2, z) - y - 1
                    // let url = that.baseMapTemplate.replace('{z}', z).replace('{x}', x).replace('{-y}', y_) 
                    let url = mUrl.replace('{z}', z).replace('{x}', x).replace('{-y}', y_) 
                    let subUrl = url.replace(/^.*(?=\/getTile)/, '')  
                    url = url + `&sign=${md5(subUrl + sk)}`    
                    // console.log(tileCoord,url)
                    // console.log('subUrl',subUrl)
                    // console.log('sk',sk)
                    return url
                  }
                })
              }else{
                source = new XYZ({
                  // crossOrigin:'anonymous',
                  projection: 'EPSG:4326',//这里是影像的投影
                  // projection: that.mapParams.projection,
                  maxZoom: 18,
                  minZoom: 0,
                  tileGrid: new TileGrid({
                    extent: ext,
                    origin: [-180,-90],//必须是这个，否则对应不上
                    resolutions: resolutions,
                  }),
                  tileUrlFunction: function(tileCoord){
                    let z = tileCoord[0];
                    let x = tileCoord[1];
                    let y = tileCoord[2];
                    return `${mUrl}/${z}/${x}/${y}.png`
                  },
                  // url:mUrl,
                })
              }
              lyr = new Tile({
                title: mTitle,
                name: mName,
                visible: mVisible,
                key:mKey,
                source:source,
                layersForLegend:layersForLegend,
                displayInLayerSwitcher: display, //在图层面板中不显示
                BBOX:ext,
                type:mType 
              })
            }

            lyrArr.push(lyr)
          } else if (lyrType === 'lVector' && srcType === 'Vector') {
            //console.log("此为lVector-Vector类型");

            // let tempMarks={};
            // let per= 100/(times.length-1);
            // for (let i = 0; i < times.length; i++) {
            //   const element = i*per;
            //   tempMarks[element]=times[i];
            // }
            // that.marks=tempMarks;
            // times.forEach(time=>{

              lyr = new lVector({
                // title: time,
                // name: time,
                title: mTitle,
                name: mName,
                visible: mVisible,
                key:mKey,
                source: new Vector({
                  format: new GeoJSON(),
                  projection: 'EPSG:4326',
                  // url: time,//这里因为改成别的不能传参，所以暂时用这个，待改!
                  // loader:vectorLoader
                }),
                // style: that.styles[mTitle]
                style:new Style({
                  stroke: new Stroke({color: 'rgba(0, 255, 255, 1)',width: 2}),
                  fill: new Fill({color: 'rgba(255, 255, 255, 0)'}),
                })
              })
              lyrArr.push(lyr);

              let href=window.location.href
              if (/(RSsserviceManage)|(viewMapSource)/.test(href)&&mUrl) {
                let geom = JSON.parse(mUrl)
                let feature=new Feature({
                  geometry: geom.type=='MultiPolygon'?new MultiPolygon(geom.coordinates):new Polygon(geom.coordinates)
                })
                feature.getGeometry().transform('EPSG:4326', that.mapParams.projection)
                lyr.getSource().addFeature(feature)
                
                // let ext=this.changeBboxFromLonLat(lyrdata[1].mExtent)
                let ext = lyr.getSource().getExtent()
                map.getView().fit(ext)//先这么跳着，有矢量就跳矢量
              }
            // })
          } else if (lyrType === 'lVector' && srcType === 'Cluster') {
            //console.log("此为lVector-Cluster类型");
            let vectorSource = new Vector({
              format: new GeoJSON(),
              projection: 'EPSG:4490',
              loader: vectorLoader,
            })
            let tempResolution = that.cluResolution;
            let tempDistance = that.cluDistance;
            lyr = new lVector({
              title: mTitle,
              name: mName,
              visible: mVisible,
              //extent:mExtent, //左下点-右上点
              minResolution: tempResolution,
              key:mKey,
              source: new Cluster({
                distance: tempDistance,
                source: vectorSource,
                params:{
                  BBOX:ext
                },
                geometryFunction: function(feature) {
                  //获取多边形内点的方法
                  let geom = feature.getGeometry()
                  if (geom instanceof Polygon) {
                    return feature.getGeometry().getInteriorPoint()
                  } else if (geom instanceof MultiPolygon) {
                    return feature
                      .getGeometry()
                      .getInteriorPoints()
                      .getPoint(0)
                  }
                }
              }),
              style: styleFunction
            })
            lyrArr.push(lyr)

            let lyr1 = new lVector({
              title: mTitle,
              name: mName,
              visible: mVisible,
              displayInLayerSwitcher: false, //在图层面板中不显示
              maxResolution: tempResolution,
              key:mKey,
              source: new Vector({
                format: new GeoJSON(),
                projection: 'EPSG:4490',
                // url: mUrl,
                params:{
                  BBOX:ext
                },
                loader: vectorLoader
              })
            })
            lyrArr.push(lyr1)
          } else if (lyrType === 'Tile' && srcType === 'OSM') {
            lyr = new Tile({
              title: mTitle,
              name: mName,
              visible: mVisible,
              key:mKey,
              source: new OSM()
            })
            lyrArr.push(lyr)
          } else if (lyrType === 'MapboxVectorLayer' && srcType === 'MapboxVectorLayer') {//矢量切片
            let country =new MapboxVectorLayer({
              styleUrl:require('./fontStyles/countryStyle.json')
            });
            let city =new MapboxVectorLayer({
              styleUrl:require('./fontStyles/cityStyle.json')
            });
            let road =new MapboxVectorLayer({
              styleUrl:require('./fontStyles/roadStyle.json')
            });
            let line =new MapboxVectorLayer({
              styleUrl:require('./fontStyles/lineStyle.json')
            });
            lyrArr.push(country,city,road ,line)
          }else if (lyrType === 'Group') {
            let lG = []
            for (let i = 0; i < mSubLayers.length; i++) {
              let lyr4tmps = null
              lyr4tmps =await addLyr4init(
                mSubLayers[i].lyrType,
                mSubLayers[i].srcType,
                mSubLayers[i].mUrl,
                mSubLayers[i].mTitle,
                mSubLayers[i].mName,
                mSubLayers[i].mVisible,
                mSubLayers[i].mExtent,
                mSubLayers[i].mSubLayers,
                mSubLayers[i].mKey,
                mSubLayers[i].sk,
                mSubLayers[i].mType,
              )
              lyr4tmps.forEach(value => {
                lG.push(value)
              })
            }
            lyr = new Group({
              title: mTitle,
              visible: mVisible,
              layers: lG
            })
            lyrArr.push(lyr)
          } else {
            console.log('抱歉，地图资源类型不明，请检查并重试，或联系管理员协助解决。')
          }
          return lyrArr
        }
        //endregion


        //region 定义“测量”和“勾绘”过程中用到的临时工作矢量层
        /*说明：这里只定义先不加载，等下面点击量测菜单或勾绘按钮后才加载*/
        that.source = new Vector() //图层数据源
        that.vector = new lVector({
          //title: '量测Measurement', //在图层面板中显示
          title: '临时工作图层（绘制图形用）', //在图层面板中显示
          source: that.source,
          //displayInLayerSwitcher:false,//设为false可以让此图层不显示在图层管理面板中
          style: new Style({
            //图层样式
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0)' //填充颜色
            }),
            stroke: new Stroke({
              color: '#ffcc33', //边框颜色
              width: 2 // 边框宽度
            }),
            image: new Circle({
              radius: 7,
              fill: new Fill({
                color: '#ffcc33'
              })
            })
          })
        })
        //endregion

        //region 测量功能
        //OpenLayer5中已封装好与椭球相关的getLength和getArea方法
        //var wgs84Sphere = new ol.Sphere(6378137); //定义一个球对象
        /**
         * 当前绘制的要素（Currently drawn feature.）
         * @type {ol.Feature}
         */
        var sketch
        /**
         * 帮助提示框对象（The help tooltip element.）
         * @type {Element}
         */
        var helpTooltipElement
        /**
         *帮助提示框显示的信息（Overlay to show the help messages.）
         * @type {ol.Overlay}
         */
        var helpTooltip
        /**
         * 测量工具提示框对象（The measure tooltip element. ）
         * @type {Element}
         */
        var measureTooltipElement
        /**
         *测量工具中显示的测量值（Overlay to show the measurement.）
         * @type {ol.Overlay}
         */
        var measureTooltip
        /**
         *  当用户正在绘制多边形时的提示信息文本
         * @type {string}
         */
        var continuePolygonMsg = '继续点击绘制多边形'
        /**
         * 当用户正在绘制线时的提示信息文本
         * @type {string}
         */
        var continueLineMsg = '继续点击绘制线'

        /**
         * 鼠标移动事件处理函数
         * @param {ol.MapBrowserEvent} evt
         */
        var pointerMoveHandler = function(evt) {
          if (evt.dragging) {
            return
          }
          /** @type {string} */
          var helpMsg = '点击开始绘制' //当前默认提示信息
          //判断绘制几何类型设置相应的帮助提示信息
          if (sketch) {
            var geom = sketch.getGeometry()
            if (geom instanceof Polygon) {
              helpMsg = continuePolygonMsg //绘制多边形时提示相应内容
            } else if (geom instanceof LineString) {
              helpMsg = continueLineMsg //绘制线时提示相应内容
            }
          }
          helpTooltipElement.innerHTML = helpMsg //将提示信息设置到对话框中显示
          helpTooltip.setPosition(evt.coordinate) //设置帮助提示框的位置
        }
        //鼠标移动与动态帮助提示
        function mapPointMove() {
          map.on('pointermove', pointerMoveHandler) //地图容器绑定鼠标移动事件，动态显示帮助提示框内容
        }

        var typeSelect = 'area' //全局变量，默认值为‘area’测面
        var distanceDiv = document.getElementById('distance') //测量类型对象-距离
        var areaDiv = document.getElementById('area') //测量类型对象-面积
        var draw //全局变量，以便后续移除

        //点击测距离
        bus.$off('distance')
        bus.$on('distance',function () {
          // if (this.isLeftVector) this.triggerClean() //左侧绘制矢量时先清空
            map.removeLayer(that.vector) //先移除再添加，否则控制台报错
            map.addLayer(that.vector)
            map.removeInteraction(draw) //移除绘制图形
            typeSelect = 'distance'
            addInteraction() //添加绘图进行测量
            mapPointMove() //鼠标移动与动态帮助提示
          }.bind(this)
        ) //监听量测中“距离”按钮的点击事件 by qhy

        //点击测面积
        bus.$off('area')
        bus.$on('area',function() {
          // if (this.isLeftVector) this.triggerClean() //左侧绘制矢量时先清空
            map.removeLayer(that.vector)
            map.addLayer(that.vector)
            map.removeInteraction(draw) //移除绘制图形
            typeSelect = 'area'
            addInteraction() //添加绘图进行测量
            mapPointMove() //鼠标移动与动态帮助提示
          }.bind(this)
        ) //监听量测中“面积”按钮的点击事件 by qhy

      //点击绘制矩形
      bus.$off('rec')
      bus.$on('rec', function () {
        // if (this.isLeftVector) this.triggerClean() //左侧绘制矢量时先清空
        map.removeLayer(that.vector)
        map.addLayer(that.vector)
        map.removeInteraction(draw) //移除绘制图形
        typeSelect = 'rec'
        addInteraction() //添加绘图进行测量
        mapPointMove() //鼠标移动与动态帮助提示
      }.bind(this)
      )

      //点击绘制圆形
      bus.$off('circle')
      bus.$on('circle', function () {
        // if (this.isLeftVector) this.triggerClean() //左侧绘制矢量时先清空
        map.removeLayer(that.vector)
        map.addLayer(that.vector)
        map.removeInteraction(draw) //移除绘制图形
        typeSelect = 'circle'
        addInteraction() //添加绘图进行测量
        mapPointMove() //鼠标移动与动态帮助提示
      }.bind(this)
      )

      //绘制季新图区域
      bus.$off('buyArea')
      bus.$on('buyArea', function (type) {
        // if (this.isLeftVector) this.triggerClean() //左侧绘制矢量时先清空
        map.removeLayer(that.vector)
        map.addLayer(that.vector)
        map.removeInteraction(draw) //移除绘制图形
        typeSelect = type
        that.needEmit = true
        addInteraction() //添加绘图进行测量
        mapPointMove() //鼠标移动与动态帮助提示
      }.bind(this)
      )
        //点击“清除”量测结果
        bus.$off('clean')
        bus.$on('clean',function() {
            if (draw) {
              draw.setActive(false) //取消激活状态，以便退出绘制
            }
            var ols = map.getOverlays()
            ols.clear() //把所有覆盖物（测量结果）都清楚掉
            map.removeLayer(that.vector) //把vector图层也清除掉，从而清除测量图形
            //注：此处不能通过var定义局部变量，会导致全局vector调用局部source而报错
            that.source = null //先清空全局变量source
            that.source = new Vector() //再实例化一个矢量图层给全局变量source，从而消除上次测量残留
            that.vector.setSource(that.source) //更新vector的新源，避免本次量测残留图形对后续新量测的影响
            that.drawFinished=false
            that.leftdrawFinished = false
            that.needEmit = false
            that.str_wkt = null
            that.str_area = null
            that.distroyKeys()
          }.bind(this)
        ) //监听量测中“清除”按钮的点击事件 by qhy

        /**
         * 加载交互绘制控件函数
         */
        function addInteraction() {
          var type = ''
        var recBox = ''//判断矩形添加属性
        switch (typeSelect) {
          case ('area'): type = 'Polygon'; break;
          case ('rec'): type = 'Circle'; recBox = createBox(); break;
          case ('circle'): type = 'Circle'; break;
          case ('distance'): type = 'LineString'; break;
        }
          draw = new Draw({
            source: that.source, //测量绘制层数据源
            type: /** @type {ol.geom.GeometryType} */ (type), //几何图形类型
            geometryFunction: recBox,
            style: new Style({
              //绘制几何图形的样式
              fill: new Fill({
                color: 'rgba(255, 255, 0, 0.2)' //浅黄色
              }),
              stroke: new Stroke({
                // color: 'rgba(0, 0, 0, 0.5)',
                color: 'rgba(255, 255, 0, 0.7)', //黄色
                lineDash: [10, 10],
                width: 2
              }),
              image: new Circle({
                radius: 5,
                stroke: new Stroke({
                  color: 'rgba(0, 0, 0, 0.7)' //黑色
                }),
                fill: new Fill({
                  // color: 'rgba(255, 255, 255, 0.2)'
                  color: 'rgba(255, 0, 255, 0.5)' //紫红色
                })
              })
            })
          })
          map.addInteraction(draw)

          createMeasureTooltip() //创建测量工具提示框
          createHelpTooltip() //创建帮助提示框

          function escEvent(event) {
          console.log(event);
          if (event.keyCode == 27) {//esc
            // map.removeInteraction(draw);
            if (draw) {
              draw.setActive(false) //取消激活状态，以便退出绘制
            }
            var ols = map.getOverlays()
            ols.clear() //把所有覆盖物（测量结果）都清楚掉
            // map.removeLayer(that.vector) //把vector图层也清除掉，从而清除测量图形
            // //注：此处不能通过var定义局部变量，会导致全局vector调用局部source而报错
            // that.source = null //先清空全局变量source
            // that.source = new Vector() //再实例化一个矢量图层给全局变量source，从而消除上次测量残留
            // that.vector.setSource(that.source) //更新vector的新源，避免本次量测残留图形对后续新量测的影响
            that.drawFinished = true
            that.leftdrawFinished = true
          }

        }
          var listener
          //绑定交互绘制工具开始绘制的事件
          draw.on('drawstart',function(evt) {
              // set sketch
              sketch = evt.feature //绘制的要素

              /** @type {ol.Coordinate|undefined} */
              var tooltipCoord = evt.coordinate // 绘制的坐标
              //绑定change事件，根据绘制几何类型得到测量长度值或面积值，并将其设置到测量工具提示框中显示
              listener = sketch.getGeometry().on('change', function(evt) {
                var geom = evt.target //绘制几何要素
                var output
                if (geom instanceof Polygon) {
                  output = formatArea(/** @type {ol.geom.Polygon} */ (geom)) //面积值
                  tooltipCoord = geom.getInteriorPoint().getCoordinates() //坐标
                } else if (geom instanceof LineString) {
                  output = formatLength(/** @type {ol.geom.LineString} */ (geom)) //长度值
                  tooltipCoord = geom.getLastCoordinate() //坐标
                }
                if (that.isMeasure) {
                  measureTooltipElement.innerHTML = output //将测量值设置到测量工具提示框中显示
                  measureTooltip.setPosition(tooltipCoord) //设置测量工具提示框的显示位置
                }
              })
              document.addEventListener('keydown',escEvent)
            },
            this
          )
          //绑定交互绘制工具结束绘制的事件
          draw.on('drawend', function (evt) {
            document.removeEventListener('keydown',escEvent)
              if (evt.feature.getGeometry().getType() == 'Polygon') {
                // if (area > 10000) {
                //   output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>'
                // } else {
                //   output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>'
                // }
                let area = measureTooltipElement.innerHTML;
                if (/km/.test(area)) {
                  area=area.replace('km<sup>2</sup>','km²')
                } else {
                  area=area.replace('m<sup>2</sup>','m²')
                }
                evt.feature.set('area',area)
              }
              if (evt.feature.getGeometry().getType() == 'LineString') {
                let distance = measureTooltipElement.innerHTML;
                // if (/km/.test(distance)) {
                //   distance=distance.replace(' km','千米')
                // } else {
                //   distance=distance.replace(' m','米')
                // }
                evt.feature.set('distance', distance)
              }  
              measureTooltipElement.className = 'tooltip tooltip-static' //设置测量提示框的样式
              measureTooltip.setOffset([0, -7])
              // unset sketch
              sketch = null //置空当前绘制的要素对象

              // unset tooltip so that a new one can be created
              measureTooltipElement = null //置空测量工具提示框对象
              createMeasureTooltip() //重新创建一个测试工具提示框显示结果

              helpTooltipElement.style.display = 'none'
              unByKey(listener)
              draw.setActive(false) //取消激活状态，以便退出绘制

              if(that.needEmit){ //季新图下单检查
                let shape = new GeoJSON().writeFeature(evt.feature, {
                  dataProjection: 'EPSG:4326',
                  featureProjection: 'EPSG:3857',
                })
                shape = JSON.parse(shape)
                let param=new FormData();
                param.append('geom',JSON.stringify(shape.geometry));
                that.axios.post("/map_service_back/program/geomAreaHandle", param, {
                  headers: {
                    Authorization: "Bearer " + that.getKey(),
                  },
                }).then(res => {
                  that.makeBufferRegion(res)
                })
              }
              else if (that.isLeftVector) that.leftdrawFinished = true //判断是否左侧绘制完成
              else {
                that.drawFinished = true
              }
            },
            this
          )
        }

        /**
         *创建一个新的帮助提示框（tooltip）
         */
        function createHelpTooltip() {
          if (helpTooltipElement) {
            helpTooltipElement.parentNode.removeChild(helpTooltipElement)
          }
          helpTooltipElement = document.createElement('div')
          helpTooltipElement.className = 'tooltip hidden'
          helpTooltip = new Overlay({
            element: helpTooltipElement,
            offset: [15, 0],
            positioning: 'center-left'
          })
          map.addOverlay(helpTooltip)
        }
        /**
         *创建一个新的测量工具提示框（tooltip）
         */
        function createMeasureTooltip() {
          if (measureTooltipElement) {
            measureTooltipElement.parentNode.removeChild(measureTooltipElement)
          }
          measureTooltipElement = document.createElement('div')
          measureTooltipElement.className = 'tooltip tooltip-measure'
          measureTooltip = new Overlay({
            element: measureTooltipElement,
            offset: [0, -15],
            positioning: 'bottom-center'
          })
          map.addOverlay(measureTooltip)
        }

        /**
         * 测量长度输出
         * @param {ol.geom.LineString} line
         * @return {string}
         */

        var formatLength = function(line) {
          var length = getLength(line, {
            projection: that.mapParams.projection
          })
          var output
          if (length > 100) {
            output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km'
          } else {
            output = Math.round(length * 100) / 100 + ' ' + 'm'
          }
          return output
        }

        /**
         * 测量面积输出
         * @param {ol.geom.Polygon} polygon
         * @return {string}
         */
        var formatArea = function(polygon) {
          //第二个formatArea函数了，这里还是用area全局变量吧
          area = getArea(polygon, {
            projection: that.mapParams.projection
          })
          var output
          if (area > 10000) {
            output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>'
          } else {
            output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>'
          }
          return output
        }
        //endregion 测量功能

        //region 点击“勾绘”进行信息采集
        /*勾绘地块-openlayer绘制多边形并自动计算多边形面积*/
        var MyDraw
        bus.$on('draw',function() {
            if (!that.flagJL) {
              that.$message.success("请先停止卷帘控制！");
              return
            }
            //让当前DIV被锁定，处于不可点击状态
            var draw = new Draw({
              //绘制对象
              source: that.source, //绘制层数据源,勾绘的要素属于的数据集
              // type: /** @type {ol.geom.GeometryType} */(value), //几何图形类型
              type: 'Polygon',
              style: new Style({
                fill: new Fill({
                  color: 'rgba(255,255,255,0.2)'
                }),
                stroke: new Stroke({
                  color: '#ffcc33',
                  width: 2
                }),
                image: new Circle({
                  radius: 7,
                  fill: new Fill({
                    color: '#ffcc33'
                  })
                })
              })
            })

            /**
             * 当前绘制的要素（Currently drawn feature.）
             * @type {ol.Feature}
             */
            var sketch
            /**
             * 帮助提示框对象（The help tooltip element.）
             * @type {Element}
             */
            var helpTooltipElement
            /**
             *帮助提示框显示的信息（Overlay to show the help messages.）
             * @type {ol.Overlay}
             */
            var helpTooltip
            /**
             * 测量工具提示框对象（The measure tooltip element. ）
             * @type {Element}
             */
            var measureTooltipElement
            /**
             *测量工具中显示的测量值（Overlay to show the measurement.）
             * @type {ol.Overlay}
             */
            var measureTooltip
            /**
             *  当用户正在绘制多边形时的提示信息文本
             * @type {string}
             */
            var continuePolygonMsg = '继续点击绘制多边形'

            /**
             * 鼠标移动事件处理函数
             * @param {ol.MapBrowserEvent} evt
             */
            var pointerMoveHandler = function(evt) {
              if (evt.dragging) {
                return
              }
              /** @type {string} */
              var helpMsg = '点击开始绘制' //当前默认提示信息
              //判断绘制几何类型设置相应的帮助提示信息
              if (sketch) {
                var geom = sketch.getGeometry()
                // helpMsg = continuePolygonMsg; //绘制多边形时提示相应内容
                if (geom instanceof Polygon) {
                  helpMsg = continuePolygonMsg //绘制多边形时提示相应内容
                } else if (geom instanceof LineString) {
                  helpMsg = continueLineMsg //绘制线时提示相应内容
                }
              }
              helpTooltipElement.innerHTML = helpMsg //将提示信息设置到对话框中显示
            }
            map.on('pointermove', pointerMoveHandler) //地图容器绑定鼠标移动事件，动态显示帮助提示框内容

            // var draw; // global so we can remove it later
            /**
             * 加载交互绘制控件函数
             */
            MyDraw = {
              init: function() {
                map.removeLayer(that.vector)
                map.addLayer(that.vector) //在弹窗时勾绘的图形不至于消失

                wkt = '' //先清空原有的坐标的影响
                map.addInteraction(draw)

                createMeasureTooltip() //创建测量工具提示框
                createHelpTooltip() //创建帮助提示框

                var listener
                //绑定交互绘制工具开始绘制的事件
                draw.on('drawstart',function(evt) {
                    // set sketch
                    sketch = evt.feature //绘制的要素

                    /** @type {ol.Coordinate|undefined} */
                    var tooltipCoord = evt.coordinate // 绘制的坐标
                    //绑定change事件，根据绘制几何类型得到测量长度值或面积值，并将其设置到测量工具提示框中显示
                    listener = sketch.getGeometry().on('change', function(evt) {
                      var geom = evt.target //绘制几何要素
                      var output
                      // output = formatArea(/** @type {ol.geom.Polygon} */(geom));//面积值
                      // tooltipCoord = geom.getInteriorPoint().getCoordinates();//坐标
                      if (geom instanceof Polygon) {
                        output = formatArea(/** @type {ol.geom.Polygon} */ (geom)) //面积值
                        tooltipCoord = geom.getInteriorPoint().getCoordinates() //坐标
                      } else if (geom instanceof LineString) {
                        output = formatLength(/** @type {ol.geom.LineString} */ (geom)) //长度值
                        tooltipCoord = geom.getLastCoordinate() //坐标
                      }
                      measureTooltipElement.innerHTML = output //将测量值设置到测量工具提示框中显示
                      measureTooltip.setPosition(tooltipCoord) //设置测量工具提示框的显示位置
                    })
                  },
                  this
                )
                //绑定交互绘制工具结束绘制的事件
                draw.on('drawend',function(evt) {
                    // console.log(evt);
                    // console.log(evt.feature);
                    var ft = evt.feature
                    let geom = ft.getGeometry() //绘制几何要素
                    let output
                    if (geom instanceof Polygon) {
                      area = getArea(geom, {
                        radius: 6378137,
                        projection: that.mapParams.projection
                      })
                      output = (Math.round(area * 100) / 100) * 0.0015 //单位变成亩
                      output = output.toFixed(2)
                    }
                    var format = new GeoJSON()
                    j2 = format.writeFeature(ft)
                    // console.log(j2);
                    var obj = JSON.parse(j2)
                    var coordinates = obj.geometry.coordinates[0]

                    for (var i = 0; i < coordinates.length; i++) {
                      wkt = wkt + coordinates[i][0] + ' ' + coordinates[i][1] + ','
                    }
                    wkt = wkt.substring(0, wkt.lastIndexOf(','))

                    measureTooltipElement.className = 'tooltip tooltip-static' //设置测量提示框的样式
                    measureTooltip.setOffset([0, -7])
                    sketch = null //置空当前绘制的要素对象
                    measureTooltipElement = null //置空测量工具提示框对象
                    createMeasureTooltip() //重新创建一个测试工具提示框显示结果
                    unByKey(listener)

                    that.POLYGON = 'POLYGON(('
                    that.POLYGON += wkt
                    that.POLYGON += '))'
                    cancelMyDraw()

                    bus.$emit('triggerAdd', [that.POLYGON, output])
                  },
                  this
                )
              },
              setActive: function(active) {
                draw.setActive(active) //激活控件
              }
            } //The End of MyDraw

            bus.$on('refreshLayer', function() {
              let url =
                '/black_water/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=black_water:business&outputFormat=application%2Fjson'
              this.$axios
                .post(url)
                .then(function(response) {
                  let features = new GeoJSON().readFeatures(response.data, { featureProjection: 'EPSG:3857' })
                  console.log(features.length)
                  map.getLayers().forEach(function(value) {
                    if (value instanceof lVector && value.getProperties().title == '业务数据图层') {
                      if (value.getSource() instanceof Cluster) {
                        value.getSource().getSource().clear();
                        value.getSource().getSource().addFeatures(features);
                      }else{
                        value.getSource().clear();
                        value.getSource().addFeatures(features);
                      }
                    }
                  })
                })
                .catch(function(error) {
                  console.log(error)
                })
            })

            function cancelMyDraw(e) {
              //取消激活几何图形修改控件
              MyDraw.setActive(false)
              //$("#drawBtn").removeClass("notclick");//解除对DIV锁定，恢复为可点击可用状态
              //清除覆盖物
              var ols = map.getOverlays()
              console.log(ols)
              ols.clear() //把所有覆盖物（测量结果）都清楚掉
              map.removeLayer(that.vector) //把vector图层也清除掉，从而清除测量图形
              //注：此处不能通过var定义局部变量，会导致全局vector调用局部source而报错
              that.source = null //先清空全局变量source
              that.source = new Vector() //再实例化一个矢量图层给全局变量source，从而消除上次测量残留
              that.vector.setSource(that.source) //更新vector的新源，避免本次量测残留图形对后续新量测的影响
            }

            /**
             *创建一个新的帮助提示框（tooltip）
             */
            function createHelpTooltip() {
              if (helpTooltipElement) {
                helpTooltipElement.parentNode.removeChild(helpTooltipElement)
              }
              helpTooltipElement = document.createElement('div')
              helpTooltipElement.className = 'tooltip hidden'
              helpTooltip = new Overlay({
                element: helpTooltipElement,
                offset: [15, 0],
                positioning: 'center-left'
              })
              map.addOverlay(helpTooltip)
            }
            /**
             *创建一个新的测量工具提示框（tooltip）
             */
            function createMeasureTooltip() {
              if (measureTooltipElement) {
                measureTooltipElement.parentNode.removeChild(measureTooltipElement)
              }
              measureTooltipElement = document.createElement('div')
              measureTooltipElement.className = 'tooltip tooltip-measure'
              measureTooltip = new Overlay({
                element: measureTooltipElement,
                offset: [0, -15],
                positioning: 'bottom-center'
              })
              map.addOverlay(measureTooltip)
            }

            /**
             * 测量面积输出
             * @param {ol.geom.Polygon} polygon
             * @return {string}
             */
            var formatArea = function(polygon) {
              area = getArea(polygon, {
                //radius:6371008.8,
                radius: 6378137,
                projection: that.mapParams.projection
              })
              var output
              if (area > 10000) {
                output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>'
              } else {
                output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>'
              }
              return output
            }

            //addInteraction(); //调用加载绘制交互控件方法，添加绘图进行测量
            MyDraw.init()
          }.bind(this)
        )
        //endregion 点击“勾绘”进行信息采集

        //region 要素编辑并保存到数据库
        //定义修改几何图形功能控件
        var Modify = {
          init: function(map) {
            //初始化一个交互选择控件，并添加到地图容器中
            let vLayers = []
            map.getLayers().forEach(function(value) {
              if (value instanceof lVector && value.values_.title === '业务数据图层') {
                vLayers.push(value)
              }
            })
            this.select = new Select({
              layers: vLayers
            })
            map.addInteraction(this.select)
            //初始化一个交互编辑控件，并添加到地图容器中
            this.modify = new iModify({
              features: this.select.getFeatures() //选中的要素
            })
            map.addInteraction(this.modify)
            //设置几何图形变更的处理
            this.setEvents() //注：事实上感觉这个方法暂时没什么用

            //终于理清了这几个“事件监听”的关系和生命周期
            listener = this.select.getFeatures().on('add', function(evt) {
              console.log('图形被激活了！')
              var ft = evt.element

              // 获取修改前的几何图形信息
              var format = new GeoJSON()
              j1 = format.writeFeature(ft)
              ft.on('change', function(e) {
                console.log('图形在变动中……1……')
              })
            })

            this.modify.on('modifystart', function(evt) {
              console.log('开始修改！')
            })
            this.modify.on('modifyend', function(evt) {
              console.log('结束修改！')

              //通过走wfs服务的方式修改图层！
              let format = new WFS()
              let feature = evt.features.getArray()[0].clone()
              let geom = feature.getGeometry()
              let area = getArea(geom, { radius: 6378137, projection: that.mapParams.projection })
              feature.set('area', `${((Math.round(area * 100) / 100) * 0.0015).toFixed(2)}`) //更新数据库中面积字段，单位变成亩并保留两位小数
              feature.set('shape', geom)
              feature.setGeometryName('shape') //数据库中保存shape的字段为“shape”，没有geometry这个字段，下面去掉了
              feature.setId(evt.features.getArray()[0].getId()) //必须设置id
              feature.unset('geometry')

              let transaction = format.writeTransaction(null, [feature], null, {
                featureType: 'business', //这里不能加"black_water:"
                // featureNS: 'http://202.111.178.10:34573/black_water',
                srsName: 'CRS:84' //用于[lon，lat]顺序的备用SRS代码与“EPSG：4326”对应，因为WFS在geoserver中的默认顺序为纬度经度，跟正常使用顺序相反，所以在这里要用该代码才行！！！ by qhy!
              })

              let serializer = new XMLSerializer()
              let xml = serializer.serializeToString(transaction)

              let url = '/black_water/wfs'
              that
                .$axios({
                  method: 'POST',
                  url: url,
                  data: xml,
                  auth: {
                    username: 'admin',
                    password: '123!@#'
                  },
                  headers: {
                    'Content-Type': 'text/xml' //指定消息格式
                  }
                })
                .then(function(response) {
                  //console.log(response.data)
                  Modify.select.getFeatures().clear()
                })
                .then(function(response) {
                  bus.$emit('refreshLayer')
                })
                .catch(function(error) {
                  console.log(error)
                })
              window.event.stopPropagation()
            })

            this.select.getFeatures().on('remove', function(evt) {
              console.log('图形被取消激活！')
            })
          },
          setEvents: function() {
            var selectedFeatures = this.select.getFeatures() //选中的要素
            //添加选中要素变更事件  原来为change:active
            this.select.on('change', function() {
              selectedFeatures.forEach(selectedFeatures.remove, selectedFeatures)
              console.log('Cancel Active') //点击“取消编辑状态”时才执行
            })
          },
          setActive: function(active) {
            this.select.setActive(active) //激活选择要素控件
            this.modify.setActive(active) //激活修改要素控件
          }
        }
        //取消被选择
        function cancelSelected() {
          if (Modify.select) {
            var ftsSelected = Modify.select.getFeatures()
            ftsSelected.clear() //这会启动ftsSelected的'remove'事件，从而再走一遍上述流程
          } else {
            return
          }
        }

        //点击“启动选择/编辑状态”
        bus.$on(
          'edit',
          function(evt) {
            if (!that.flagJL) {
              that.$message.success("请先停止卷帘控制！");
              return
            }
            this.isEdit = true
            Modify.init(map) //初始化几何图形修改控件

            const dblClickInteraction = map
              .getInteractions()
              .getArray()
              .find(interaction => {
                return interaction instanceof DoubleClickZoom
              })
            map.removeInteraction(dblClickInteraction) //移除双击缩放功能，使双击只用于关闭编辑状态

            //Modify.setActive(true);    //激活几何图形修改控件
          }.bind(this)
        ) //监听“启动选择/编辑状态”按钮的点击事件 by qhy

        //endregion 要素编辑并保存到数据库


        //region 图层管理控件
        if (!document.body.classList.contains('hideOpacity')) {
          document.body.classList.add('hideOpacity')
          document.body.classList.add('hidePercent')
        }

        let lyrs=[];
        that.baseMap.forEach(layer=>{
          if (!(layer instanceof Group&&layer.values_.title==='天地图服务')) {
            lyrs.push(layer);
          }
        })
        // let lyrsForLayerSwitcher= new Group({layers: lyrs})
        // that.switcher = new LayerSwitcher({
        //   target: document.querySelector('#' + this.lyrBox),
        //   show_progress: true, //在切片图层上显示进度条，默认为false
        //   reordering: true, //允许图层重新排序，默认值为true
        //   trash: false, //添加垃圾桶按钮以删除图层，默认为false
        //   extent: true, //添加范围按钮以缩放到图层范围
        //   layerGroup:lyrsForLayerSwitcher
        // })
        //通过这种方式覆盖了LayerSwitcher.js源代码中的ol_control_LayerSwitcher.prototype.tip
        //从而重新定义了title提示信息
        // that.switcher.tip = {
        //   up: '上下移动改变图层叠加顺序[up/down]',
        //   down: '往下[down]',
        //   info: '图层相关信息说明[informations...]',
        //   extent: '跳转到该图层最大范围[zoom to extent]',
        //   trash: '移除该图层[remove layer]',
        //   plus: '展开/收缩图层组[expand/shrink]'
        // }
        // map.addControl(that.switcher)

        //重写原生switchLayerVisibility函数，使图层面板的控制追加到图例上
        // LayerSwitcher.prototype.switchLayerVisibility = function(l, layers) {
        //   if (l.values_.title==="长春市底图") {
        //     layers.forEach(ly=>{
        //       if (ly.values_.title==="公主岭市底图") {
        //         ly.setVisible(!l.getVisible());
        //       }
        //     })
        //   }
        //   //底图切换逻辑控制
        //   if (l.values_.title==="路网") {
        //     if (l.getVisible()) {
        //       return
        //     }else{
        //       layers.forEach(ly=>{
        //         if (ly.values_.title==="卫星") {
        //           ly.setVisible(l.getVisible());
        //           that.deleteFromModelist(ly,"juanlianList1");//从卷帘面板列表中删除
        //           that.deleteFromModelist(ly,"juanlianList2");//从卷帘面板列表中删除
        //         }
        //       })
        //     }
        //   }
        //   if (l.values_.title==="卫星") {
        //     if (l.getVisible()) {
        //       return
        //     }else{
        //       layers.forEach(ly=>{
        //         if (ly.values_.title==="路网") {
        //           ly.setVisible(l.getVisible());
        //           that.deleteFromModelist(ly,"juanlianList1");//从卷帘面板列表中删除
        //           that.deleteFromModelist(ly,"juanlianList2");//从卷帘面板列表中删除
        //         }
        //       })
        //     }
        //   }

        //   if (!l.get('baseLayer')) {
        //     if (l instanceof Group) {
        //       let state=l.getVisible();
        //       if (!state) {//当前是关闭的状态，要显示
        //         let hasVisible=false;
        //         l.values_.layers.forEach(ly=>{
        //           if (ly.getVisible()) {//下面有显示的
        //             hasVisible=true;
        //           }
        //         })
        //         if (!hasVisible) {//下面没有显示的则全显示，有显示的则只显示父级自己
        //           l.values_.layers.forEach(ly=>{
        //             ly.setVisible(true);
        //           })
        //         }
        //       }else{//当前是显示的状态，要关闭，全关闭
        //         l.values_.layers.forEach(ly=>{
        //           ly.setVisible(false);
        //         })
        //       }
        //     }
        //     l.setVisible(!l.getVisible());

        //     if (!l.getVisible()) {
        //       that.deleteLegend(l);
        //       that.deleteFromModelist(l,"juanlianList1");//从卷帘面板列表中删除
        //       that.deleteFromModelist(l,"juanlianList2");//从卷帘面板列表中删除
        //     }else {
        //       that.addLegend(l);
        //       that.addToModelist(l, "juanlianList1");
        //       that.addToModelist(l, "juanlianList2");
        //     }

        //   } else {//这里不知道什么时候能进入，暂时先不改了
        //     if (!l.getVisible()) l.setVisible(true);
        //     layers.forEach(function(li) {
        //       if (l!==li && li.get('baseLayer') && li.getVisible()) li.setVisible(false);
        //     });
        //   }
        // };

        // LayerSwitcher.prototype.dragOpacity_ = function(e) {
        //   e.stopPropagation();
        //   e.preventDefault();
        //   var self = this
        //   // Register start params
        //   var elt = e.target;
        //   var layer = this._getLayerForLI(elt.parentNode.parentNode.parentNode);
        //   if (!layer) return;
        //   var x = e.pageX
        //     || (e.touches && e.touches.length && e.touches[0].pageX)
        //     || (e.changedTouches && e.changedTouches.length && e.changedTouches[0].pageX);
        //   var start = ol_ext_element.getStyle (elt, 'left') - x;
        //   self.dragging_ = true;

        //   // stop dragging
        //   function stop() {
        //     ol_ext_element.removeListener(document, "mouseup touchend touchcancel", stop);
        //     ol_ext_element.removeListener(document, "mousemove touchmove", move);
        //     self.dragging_ = false;
        //   }
        //   // On draggin
        //   function move(e) {
        //     var x = e.pageX
        //       || (e.touches && e.touches.length && e.touches[0].pageX)
        //       || (e.changedTouches && e.changedTouches.length && e.changedTouches[0].pageX);
        //     var delta = (start + x) / ol_ext_element.getStyle(elt.parentNode, 'width');
        //     var opacity = Math.max (0, Math.min(1, delta));
        //     ol_ext_element.setStyle (elt, { left: (opacity*100) + "%" });
        //     elt.parentNode.nextElementSibling.innerHTML = Math.round(opacity*100);
        //     layer.setOpacity(opacity);

        //     let ul=elt.parentNode.parentNode.nextElementSibling;
        //     if (ul) {
        //       for (let i = 0; i < ul.children.length; i++) {
        //         const li = ul.children[i];
        //         let element=li.querySelector('.layerswitcher-opacity-cursor');
        //         ol_ext_element.setStyle (element, { left: (opacity*100) + "%" });
        //         self._getLayerForLI(li).setOpacity(opacity);
        //       }
        //     }
        //   }
        //   // Register move
        //   ol_ext_element.addListener(document, "mouseup touchend touchcancel", stop);
        //   ol_ext_element.addListener(document, "mousemove touchmove", move);
        // };
        //endregion 图层管理控件

        //region 选中图斑弹出信息窗口
        // Select  interaction
        // let layerForSelect = []
        // map.getLayers().forEach(value => {
        //   if (value instanceof Group) {
        //     value.values_.layers.forEach(l=>{
        //       if (l instanceof lVector||l.values_.title=="第二期矢量图层wms测试") {
        //         layerForSelect.push(l)
        //       }
        //     })
        //   }
        //   if (value instanceof lVector||value.values_.title=="第二期矢量图层wms测试") {
        //     layerForSelect.push(value)
        //   }
        //   // if (value.values_.title === '业务数据图层') {
        //   //   layerForSelect.push(value)
        //   // }
        // })

        // let select = new Select({
        //   hitTolerance: 5,
        //   multi: true,
        //   condition: singleClick,
        //   layers: layerForSelect
        // })
        // map.addInteraction(select)

        // let keys=[];//属性名
        // let promiseArray=[];
        // for(let k=0;k<that.featureTypesForAttr.length;k++){
        //   let url = '/black_water/wfs'
        //   let featureRequest = new WFS().writeGetFeature({
        //     featureTypes: [that.featureTypesForAttr[k]],
        //     maxFeatures:1,//只获取一个就行，只为了获取字段
        //     outputFormat: 'application/json',
        //   })
        //   let xml = new XMLSerializer().serializeToString(featureRequest)
        //   promiseArray.push(that.$axios({method: 'POST',url: url,data: xml,headers: {'Content-Type': 'text/xml'}}));

        // }
        // Promise.all(promiseArray).then(function(response) {
        //   response.forEach(res=>{
        //     let features = new GeoJSON().readFeatures(res.data, { featureProjection: 'EPSG:4326' })
        //     if (features.length == 0) {
        //       that.$message.success("未与地块关联");
        //       return
        //     }
        //     keys=[...keys,...features[0].getKeys()];
        //   })
        // }).then(function(){
        //   keys=[...new Set(keys)];
        //   keys=keys.filter(key=>{
        //     return key!='geometry'&&key!='the_geom';
        //   })
        //   let attrs={attributes:{}};
        //   keys.forEach(key=>{
        //     // attrs.key={
        //     attrs.attributes[key]={
        //       title:key,
        //       visible:function(f){
        //         return f.get(key);
        //       }
        //     }
        //   })
        //   let popupFeature = new PopupFeature({
        //     popupClass: 'default anim',
        //     select: select,
        //     canFix: true,
        //     template: attrs/* {
        //       // title:
        //       //   // 'nom',   // only display the name
        //       //     function(f) {
        //       //       return f.get('nom')+' ('+f.get('id')+')';
        //       //     },
        //       attributes: {
        //         block_coding: {
        //           title: '地块编码',
        //           visible: function(f) {
        //             return f.get('block_coding')
        //           }
        //         }
        //       }
        //     } */
        //   })
        //   map.addOverlay(popupFeature)
        // }).catch(function(error) {
        //     console.log(error)
        //   })

        bus.$emit('setFeatureTypes',that.featureTypesForAttr);
        //endregion
        //wms图层弹属性框以及高亮单击的图斑
        let popupForWMS = new Popup ({
          popupClass: "default anim", //"tooltips", "warning" "black" "default", "tips", "shadow",
          // closeBox: true,
          autoPan: true,
          autoPanAnimation: { duration: 100 }
        });
        map.addOverlay(popupForWMS)

        let highLightForSingleClick=new Style({fill: new Fill({color: 'rgba(223, 216, 212, 0.5)'}),stroke: new Stroke({color: 'rgba(0, 255, 255, 1)',width: 2})});//用于后面高亮每个查询到的图斑
        let highLightVectorForSingleClick = new Vector()
        new lVector({
          source: highLightVectorForSingleClick,
          map: map,
          style: highLightForSingleClick
        })

        let highLightForDblClick=new Style({fill: new Fill({color: 'rgba(223, 216, 212, 0)'}),stroke: new Stroke({color: 'rgba(0, 255, 255, 1)',width: 2})});//用于后面高亮每个查询到的图斑
        let highLightVectorForDblClick = new Vector()
        new lVector({
          source: highLightVectorForDblClick,
          map: map,
          style: highLightForDblClick
        })

        let keys={
          id:"id",
          number:"编号",
          pro:"省",
          city:"市",
          con:"县（区）",
          vil:"所属镇",
          lon:"经度",
          lat:"纬度",
          ltlx:"裸土类型",
          hcsj:"影像日期",
          remark:"备注",
          area:"面积",
          time:"时间",
          // status:"状态",
          reassign:"疑点",
          depart:"部门",
          appsj:"手机拍照时间",

          X:"经度",
          Y:"纬度",
          jgdw:"jgdw",
          xq:"辖区",
          zrzt:"zrzt",
          dcwz:"dcwz",
          mj:"面积",
          dlnr:"dlnr",
          dcl:"dcl",
          cs:"cs",
          wt:"wt",
          zgyq:"zgyq",
          zgxs:"zgxs",
          zgwcqk:"zgwcqk",
          bz:"bz",

          "企业名":"企业名称",
          "行业":"行业",
          "法人代":"法人代",
          "法人名":"法人名称",
          "行政区":"行政区",
          "规模":"规模",
          "登记注":"登记注",
          "开业时":"开业时间",
          "联系电":"联系电话",
          "污染源":"污染源",
          "中心经":"中心经度",
          "中心纬":"中心纬度",
          "产污工":"产污工",
          "污染处":"污染处",
          "排放筒":"排放筒",
          "投产日":"投产日",
          "排放规":"排放规",
          "排放设":"排放设",
          "锅炉额":"锅炉额",
          "废气类":"废气类",
          "空气质":"空气质",
          "执行标":"执行标",
          "xzq":"行政区",
          "乡镇街":"乡镇街",

          Pro:"省",
          City:"市",
          Lon:"经度",
          Lat:"纬度",
          Hcsj:"核查时间",
          Remark:"备注",
          Cou:"县（区）",
          // vil:"所属镇",
          // ltlx:"裸土类型",
          // Hcsj:"影像日期",
          // Remark:"备注",
          Dep:"部门",

          psrq:"拍摄日期",
          pszt:"卫星核查状态",
          dkss:"地块所属",
          sqxwgz:"市县区网格长",
          bmwgz:"部门网格长",
          wgy:"网格员",

          name:"名字",
          "区县":"区县",

          parts:"parts",
          province:"省",
          // city:"市",
          cou:"区",
          Area:"面积",
          water_name:"水体名称",
          start_lon:"开始经度",
          start_lat:"开始纬度",
          end_lon:"结束经度",
          end_lat:"结束纬度",
          length:"长度",
          type:"类型",
          flag:"备注",
          smelly:"是否黑臭",
          sewage_out:"是否排污口",
          watercolor:"水体颜色",
          watersmell:"气味",
          floating:"漂流物",
          status:'状态',
          floating_object:'水面大面积漂浮物',
          garbage:'河道及两岸垃圾',
          sewage_outlet:'违法排污口',
          water_color:'水体颜色是否异常',
          water_smell:'水体气味是否异常',
          trans:'透明度',
          oxygen:'溶解氧',
          ammonia:'氨氮',
          rp:'氧化还原电位',
          app_time:'APP核查时间',
          app_name:'APP核查用户',
          // reassign:'重新下发理由',
          objectid:'id',
          broad:'长*宽(m)',
          problem:'主要污染问题',
          start_point:'黑臭段起点',
          end_point:'黑臭段终点',

          solvePlan:'治理规划',
          town:'乡镇/街道',
          village:'建制村名称',
          villagePopulation:'建制村人口',
          villageArea:'建制村面积',
          relativeVillages:'涉及的自然村',
          chiefName:'河湖长姓名',
          locatedUnit:'所在单位',
          job:'职务',
          phoneNumber:'联系电话',
          isStartSolve:'是否开始治理',
          solveState:'治理进展',
        }
        // let status={
        //   30:"未调查",
        //   31:"待审核",
        //   32:"审核通过",
        //   33:"追踪中",
        // }
        async function getHtml(features,curCount,totalCount){
          // let fileData = new FormData();
          // //创建属性框
          // let html = '';
          // html += `<div class="ol-popupfeature" style="max-width:400px;max-height:250px;overflow:auto;">`;
          // html += `<i class="ol-fix"></i>`
          // html += `<table>`;
          // html += `<tr><th>属性名称</th><th>属性值</th></tr>`;
          // features.forEach(f=>{
          //   for (const key in f.values_) {
          //     if (f.values_.hasOwnProperty(key)) {
          //       const element = f.values_[key];
          //       if(key=="id"){
          //         fileData.append("id", element);
          //       }
          //       if (key!='geometry'&&key!='the_geom'&&key!='id'&&key!='PopupInfo'&&key!='conx'&&key!='解译人'&&key!='Shape_Leng'&&key!='Shape_Area'&&key!='OBJECTID'&&key!='cxhc') {
          //         if (element) {
          //           let v=element;
          //           if (key=='status') {
          //             switch(element){
          //               case '30':
          //                 v='未核查';
          //                 break;
          //               case '31':
          //                 if(f.values_.cxhc=='1') v='整改未审核';
          //                 else v='核查未审核';
          //                 break;
          //               case '32':
          //                 if(f.values_.cxhc=='1') v='整改通过';
          //                 else v='重新核查';
          //                 break;
          //               case '33':
          //                 if(f.values_.cxhc=='1') v='未整改';
          //                 else v='核查通过';
          //                 break;
          //               case '34':
          //                 v='整改未完成';
          //                 break;
          //               case '35':
          //                 v='整改未审核';
          //                 break;
          //               case '36':
          //                 v='整改通过';
          //                 break;
          //             }
          //           }
          //           if (key=='smelly') {
          //             switch(element){
          //               case '1':
          //                 v='是';
          //                 break;
          //               case '0':
          //                 v='否';
          //                 break;
          //               case '-1':
          //                 v='未核查';
          //                 break;
          //             }
          //           }
          //           html += `<tr><td>${keys[key]}</td><td>${v}</td></tr>`;
          //         }
          //       }
          //     }
          //   }
          // })
          // html += `</table>`;
          // let dataSource=[];
          // await httpAction('/pictures/picture/queryPicturesById', fileData, 'post').then((res) => {
          //   if (res.success) {
          //     let pictureUrls=[];
          //     res.result.forEach(function (item) {
          //       pictureUrls.push(item.pictureUrl);
          //     });
          //     dataSource=pictureUrls;
          //     html +=`<div>`
          //     for(let i=0;i<dataSource.length;i++){
          //       html += `<div style="float: left;width:104px;height:104px;margin-right: 10px;margin: 0 8px 8px 0;">`;
          //       html += `<div style="width: 100%;height: 100%;position: relative;padding: 8px;border: 1px solid #d9d9d9;border-radius: 4px;">`;
          //       if (/(\.mp4)|(\.avi)/i.test(dataSource[i])) {//添加播放视频功能
          //         html += `<video src="${dataSource[i]}" style="width: 100%;height:100%;" preload="auto" controls="controls" playsinline="true" webkit-playsinline="true" x5-video-player-type='h5' x5-video-player-fullscreen='true' muted preview="1"></video>`;
          //       }else{
          //         html += `<img style="width: 100%;height:100%;" src="${dataSource[i]}"  preview="1">`;
          //       }
          //       html += `</div></div>`;
          //     }
          //     html +=`</div>`
          //     html += `<button type="button" class="ol-zoombt"></button>`;
          //     if (totalCount>1) {
          //       html += `<div class="ol-count" ><div class="ol-prev"></div>${curCount}/${totalCount}<div class="ol-next"></div></div>`;
          //     }
          //     html += `</div>`;
          //   } else {
          //     html += `<button type="button" class="ol-zoombt"></button>`;
          //     if (totalCount>1) {
          //       html += `<div class="ol-count" ><div class="ol-prev"></div>${curCount}/${totalCount}<div class="ol-next"></div></div>`;
          //     }
          //     html += `</div>`;
          //   }
          // })
          // return html;
        }
        function setEventsForAttributes(featuresArr,curCount,html,evt){
          //添加缩放至/属性框定位/切换查询的图斑功能
          that.$nextTick(()=>{
            document.querySelector('.ol-fix').addEventListener('click', function(){
              popupForWMS.element.classList.toggle('ol-fixed');
            });
            document.querySelector('.ol-zoombt').addEventListener('click', function() {
              let features=featuresArr[curCount-1];
              if (features[0].getGeometry().getType()==='Point') {//没遇到过，先留着
                map.getView().animate({
                  center: features[0].getGeometry().getFirstCoordinate(),
                  zoom:  Math.max(map.getView().getZoom(), 18)
                });
              } else  {//这里没准还有其他类型的geometry，暂时只这样处理，等遇到了再改！
                let ext = new MultiPolygon(features[0].getGeometry().getCoordinates()).getExtent();
                map.getView().fit(ext, { duration:1000 });
              }
            });
            let prev=document.querySelector('.ol-prev');
            if (prev) {
              prev.addEventListener('click',async function(){
                curCount--;
                if (curCount<1) curCount = featuresArr.length;
                html =await getHtml(featuresArr[curCount-1],curCount,featuresArr.length);
                highLightVectorForSingleClick.clear();
                highLightVectorForSingleClick.addFeatures(featuresArr[curCount-1]);
                setTimeout(function() {
                  popupForWMS.show(evt.coordinate,html);
                  setEventsForAttributes(featuresArr,curCount,html,evt);//这里不知道为啥没死循环。。
                }.bind(this), 350 );
              });
            }
            let next=document.querySelector('.ol-next');
            if (next) {
              next.addEventListener('click',async function(){
                curCount++;
                if (curCount>featuresArr.length) curCount = 1;
                html =await getHtml(featuresArr[curCount-1],curCount,featuresArr.length);
                highLightVectorForSingleClick.clear();
                highLightVectorForSingleClick.addFeatures(featuresArr[curCount-1]);
                setTimeout(function() {
                  popupForWMS.show(evt.coordinate,html);
                  setEventsForAttributes(featuresArr,curCount,html,evt);//这里不知道为啥没死循环。。
                }.bind(this), 350 );
              });
            }
            // that.$previewRefresh();
          })
        }
       
        bus.$off('limitZoom')
        bus.$on('limitZoom', (limit12Level) => {
          this.limit12Level=limit12Level
          let zoom = Math.round(this.map.getView().getZoom())
          let href=window.location.href
          if (/imageSegmentation/.test(href)&&zoom > 12&&limit12Level) {
            this.map.getView().setZoom(12)
            this.show12LevelTip = true;
          }
        })

        map.on('moveend', (e) => {
          let zoom = Math.round(this.map.getView().getZoom())
          let href=window.location.href
          if (/buyCountyProduction/.test(href)&&zoom > 14) {
            this.map.getView().setZoom(14)
            // alert('购买区县季新图后可查看相应区县的18级切片影像')
            this.showCountyTip = true
            setTimeout(() => {
              this.showCountyTip = false
            },5000)  
          }
          if (/imageSegmentation/.test(href)&&zoom > 12&&this.limit12Level) {
            this.map.getView().setZoom(12)
            this.show12LevelTip = true;
          }
        })
        map.on('postrender', () => {
          this.zoomLevel = Math.round(this.map.getView().getZoom())
          // console.log('map.tileQueue_.getTilesLoading()',map.tileQueue_.getTilesLoading())
          // if (map.tileQueue_.getTilesLoading() == 0) {
          //   debugger
          // }
        })
        //region （监听）地图单击和双击的全局事件
        map.on(
          'singleclick',
          function(evt) {
            highLightVectorForSingleClick.clear();

            let wmsVectorLayers=[];
            map.getLayers().forEach(layer => {//待改
              if (layer instanceof Group) {
                layer.values_.layers.forEach(l=>{
                  if (l.values_.visible&&(l.getSource() instanceof ImageWMS||l.getSource() instanceof TileWMS)&&(/黑臭水体/i.test(l.values_.title)||(/解译点/i.test(l.values_.title)))) {
                    wmsVectorLayers.push(l);
                  }
                })
              }else{
                if (layer.values_.visible&&(layer.getSource() instanceof ImageWMS||layer.getSource() instanceof TileWMS)&&(/黑臭水体/i.test(layer.values_.title)||(/解译点/i.test(layer.values_.title)))) {
                  wmsVectorLayers.push(layer);
                }
              }
            })
            let viewResolution = map.getView().getResolution();
            let tURLs = [];
            let axiosArr = [];
            wmsVectorLayers.forEach(ly=>{
              let lySource=ly.getSource();
              // let s=lySource.url_.match(/(?<=layers=).+?(?=&)/i);//匹配前面是layers后面是&的非贪婪字符串
              let s=lySource.url_.match(/layers=.+?(?=&)/i);
              s[0]=s[0].split("=")[1];
              let url=lySource.getGetFeatureInfoUrl(
                evt.coordinate, viewResolution, that.mapParams.projection,
                {'INFO_FORMAT': 'application/json','QUERY_LAYERS': s[0],});
              tURLs.push(url);
              axiosArr.push(that.$axios(url));
            })

            if (tURLs.length>0) {
              that.$axios.all(axiosArr)
              .then(function(res) {
                let featuresArr=[];
                let hidePopup=true;
                res.forEach(response=>{
                  if (response.data.features.length>0) {
                    hidePopup=false;
                    let features = new GeoJSON().readFeatures(response.data, { featureProjection: that.mapParams.projection })
                    featuresArr.push(features);
                  }
                })
                if (hidePopup) {
                  popupForWMS.hide();
                }else{
                  return featuresArr;
                }
              })
              .then(async function(featuresArr){
                if (featuresArr) {
                  let curCount=1;//当前显示的第几个图斑
                  let html=await getHtml(featuresArr[0],curCount,featuresArr.length);
                  highLightVectorForSingleClick.addFeatures(featuresArr[0]);
                  popupForWMS.show(evt.coordinate,html);//初始高亮显示查到的第一个图斑
                  setEventsForAttributes(featuresArr,curCount,html,evt);
                }
              })
              .catch(function(error) {
                console.log(error)
              })
            }
            // this.$previewRefresh();
            document.querySelector('#' + this.lyrBox).style.display =  'none';//关掉图层面板
            console.log(map.getView().getResolution());
          }.bind(this)
        )

        map.on('singleclick', async evt => {
          
          let visiableMk=[]
          // let allLayers = map.getLayerGroup().getLayersArray()
          // allLayers.forEach(layer => {
          //   if (layer instanceof Tile && layer.getVisible() && layer.values_.title!='天地图注记') { 
          //     let url = layer.getSource().urls[0]
          //     // 获取mk
          //     let mk = url.match(/mk=(\S*)&tk/)[1];
          //     visiableMk.push(mk)
          //   }
          // })
          // this.curMk=visiableMk[0]
          this.curMk=this.$parent.curMk
          map.forEachFeatureAtPixel(evt.pixel,(feature,layer)=>{
            // console.log('feature', feature)
            if (layer&&layer.values_.title == '边框') {//如果点的位置是边框图层中的矢量，则把curMk赋值成该矢量对应图的mk
              this.curMk=visiableMk.at(-1)
            }
          })
          if (this.zoomLevel >= 10) {   
            let coordinate=toLonLat(evt.coordinate)
            await this.axios.get(`/map_service_back/getTileInfo/${that.zoomLevel}/${coordinate[0]}/${coordinate[1]}?mk=${that.curMk}&tk=${that.curTk}`).then(res => {
              if (res.data.code==200) {
                this.imagingTime=res.data.data
                this.showShootTime = true;   
              }
              else{
                this.showShootTime = false;   
              }
            }).catch(function(error) {
              console.log(error)
            })  
          } else {
            this.showShootTime = false;      
          }
        })

        map.on(
          'dblclick',
          function(evt) {
            if (this.isEdit) {
              map.removeInteraction(Modify.select) //（关键动作）移除选择交互
              map.removeInteraction(Modify.modify) //（关键动作）移除修改交互
              unByKey(listener) //使得第二次点击到图形时，图形不被激活
              this.isEdit = false
            }

            highLightVectorForDblClick.clear();
            let wmsVectorLayers=[];
            map.getLayers().forEach(layer => {
              if (layer instanceof Group) {
                layer.values_.layers.forEach(l=>{
                  if (l.values_.visible&&(l.getSource() instanceof ImageWMS||l.getSource() instanceof TileWMS)&&(/[裸堆点棚区]/i.test(l.values_.title))) {
                    wmsVectorLayers.push(l);
                  }
                })
              }else{
                if (layer.values_.visible&&(layer.getSource() instanceof ImageWMS||layer.getSource() instanceof TileWMS)&&(/[裸堆点棚区]/i.test(layer.values_.title))) {
                  wmsVectorLayers.push(layer);
                }
              }
            })
            let viewResolution = map.getView().getResolution();
            let tURLs = [];
            let axiosArr = [];
            wmsVectorLayers.forEach(ly=>{
              let lySource=ly.getSource();
              let s=lySource.url_.match(/layers=.+?(?=&)/i);
              s[0]=s[0].split("=")[1];
              let url=lySource.getGetFeatureInfoUrl(
                evt.coordinate, viewResolution, that.mapParams.projection,
                {'INFO_FORMAT': 'application/json','QUERY_LAYERS': s[0],});
              tURLs.push(url);
              axiosArr.push(that.$axios(url));
            })

            if (tURLs.length>0) {
              that.$axios.all(axiosArr)
              .then(function(res) {
                let featuresArr=[];
                let hidePopup=true;
                res.forEach(response=>{
                  if (response.data.features.length>0) {
                    hidePopup=false;
                    let features = new GeoJSON().readFeatures(response.data, { featureProjection: that.mapParams.projection })
                    featuresArr.push(features);
                  }
                })
                if (hidePopup) {
                  popupForWMS.hide();
                }else{
                  return featuresArr;
                }
              })
              .then(async function(featuresArr){
                if (featuresArr) {
                  let geometry=featuresArr[0][0].getGeometry();
                  if (!(geometry.getType()=='MultiPoint'||geometry.getType()=='point')) {
                    let ext=geometry.getExtent();
                    map.getView().fit(ext);
                  }
                  highLightVectorForDblClick.clear();
                  let name=featuresArr[0][0].values_.区县;

                  //判断是不是首页，如果不是则不更新图表数据
                  let isHome=false;
                  let href=window.location.href;
                  if (/dashboard\/analysis/i.test(href)) isHome=true;
                  // if (that.nameDetail != featuresArr[0][0].values_.name) {
                  //   that.nameDetail = featuresArr[0][0].values_.name
                  if (that.nameDetail != featuresArr[0][0].values_.区县) {
                    that.nameDetail = featuresArr[0][0].values_.区县
                    highLightVectorForDblClick.addFeatures(featuresArr[0])
                    if (isHome) {
                      //选中
                      let param = {con:name};
                      bus.$emit('refreshData',param);
                    }

                  } else {
                    that.nameDetail = ''
                    if (isHome) {
                      //反选
                      let param = {con:''};
                      bus.$emit('refreshData',param);
                    }
                  }

                }
              })
              .catch(function(error) {
                console.log(error)
              })
            }
            // this.$previewRefresh();
          }.bind(this)
        )
        //endregion

        //region图表联动
        let highLightVectorSource = new Vector()
        let featureOverlay = new lVector({
          source: highLightVectorSource,
          map: map,
          style: new Style({
            stroke: new Stroke({
              color: 'rgb(0,255,255)',
              width: 2
            }),
            fill: new Fill({
              color: 'rgba(255,0,0,0)'
            }),
            text: new Text({
              font: '12px Calibri,sans-serif',
              fill: new Fill({
                color: '#fff'
              }),
              stroke: new Stroke({
                color: '#f00',
                width: 1
              })
            })
          })
        })

        bus.$off('tableToPicture')
        bus.$on('tableToPicture', (data, type, ...arr) => {
          let url = '/blackwater/wfs'
          let filter = 'id'
          let filterValue = data[filter]

          /*  if (type) {
             //查勘管理要用这个
             filter = 'insurance_number'
             filterValue = data['insuranceNumber']
           } */

          //首先要清除掉原来操作的高亮图层
          highLightVectorSource.clear()
          let featureRequest = new WFS().writeGetFeature({
            featureTypes: arr,
            outputFormat: 'application/json',
            filter: equalTo(filter, filterValue) //过滤条件
          })

          let xml = new XMLSerializer().serializeToString(featureRequest)

          that
            .$axios({
              method: 'POST',
              url: url,
              data: xml,
              headers: {
                'Content-Type': 'text/xml' //指定消息格式
              }
            })
            .then(function(response) {
              let features = new GeoJSON().readFeatures(response.data, { featureProjection: that.mapParams.projection })
              features[0].getGeometry().transform('EPSG:4326', that.mapParams.projection);//将坐标系由4326转为3857
              if (features.length == 0) {
                that.$message.success("未与地块关联");
                return
              }

              // 让查询结果在地图上高亮显示
              highLightVectorSource.addFeatures(features)
              // 调整结果显示范围
              let ext = highLightVectorSource.getExtent()
              // let x1 = ext[0]
              // let y1 = ext[1]
              // let x2 = ext[2]
              // let y2 = ext[3]

              var center = getCenter(ext);

              // //扩大两倍
              // let a1 = 2 * x1 - x2
              // let a2 = 2 * x2 - x1
              // let b1 = 2 * y1 - y2
              // let b2 = 2 * y2 - y1


              // let ext_new = [a1, b1, a2, b2]
              //之前用的是这种方式跳转
              // map.getView().fit(ext)

              //map.getView().animate({center: (center)},{zoom: 19}) //先移动，再缩放

              map.getView().setCenter(center);
              map.getView().setZoom(18);
              // let resolution = map.getView().getResolution();
              // let temp=that.cluResolution-0.0000001;
              // if (resolution > temp) {
              //   map.getView().setResolution(temp);
              // }
            })
            .catch(function(error) {
              console.log(error)
            })
        })
        //endregion图表联动

        //LayerSwitcherImage用于控制底图
        let lyrsForOverview=[];//用于鹰眼的底图
        let lyrsForLayerSwitcherImage={};
        that.baseMap.forEach(layer=>{
          if (layer instanceof Group&&layer.values_.title==='天地图服务') {
            lyrsForLayerSwitcherImage=layer;
            lyrsForOverview.push(layer);
          }
        })
        // map.addControl (new LayerSwitcherImage({
        //   layerGroup:lyrsForLayerSwitcherImage
        // }));

        //鹰眼功能
        let ov = new Overview({
          projection:this.mapParams.projection,
          layers: lyrsForOverview,
          // layers: [new Tile({source:new XYZ({url: 'http://webrd03.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scale=1&style=8'})})],//高德地图
          // layers: [new Tile({source:new TileWMS({url: "http://202.111.178.10:34573/geoserver/JLNB/wms?LAYERS=JLNB:JilinProvinceImagery16m&TILED=true&serverType=geoserver"})})],//吉林省16m影像图层
          // minZoom: 5,
          // maxZoom: 5,
          style:new Style({
            //图层样式
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.2)' //填充颜色
            }),
            stroke: new Stroke({
              color: 'red', //边框颜色
              width: 2 // 边框宽度
            }),
          }),
          align: 'bottom-right',
          // panAnimation: "elastic"
        });
        // map.addControl(ov);

        //卷帘功能
        // this.addLyrListToJuanlianPanel();


        // //图例功能
        // let legend = new Legend({
        //   title: '图例',
        //   collapsed: false //true:初始化页面时收缩,false:初始化页面时打开
        // })
        // map.addControl(legend)

        that.location = new Vector({
            crossOrigin: 'Anonymous'
        })
        let v = new lVector({
            source: that.location,
        })
        that.map.addLayer(v)//定位跳转时需要

        bus.$off('cancelhighlight');
        bus.$on('cancelhighlight',()=>{
          highLightVectorSource.clear();
        });

        bus.$emit('loadGisMapRunOver')
      },
      getKey() {
        return localStorage.getItem("token");
      },
      
      //销毁绘制的监听和临时图层
    distroyKeys() {
      unByKey(this.key_move);
      unByKey(this.key_click);
      this.map.removeLayer(this.area_vector)
    },
    //根据经纬度设置正方形框
    setSquareAreaByCoordinates(area=25,coordinate) {
      let that = this
     
      let kilometers = 1000000    //千米转化为米
      let tmpArea = area;
      let true_area = kilometers*tmpArea
      let length = Math.sqrt(true_area) / 2

      // //先清除上一预览图形
      that.map.removeLayer(that.area_vector)

      //转换至经纬度计算，保证面积准确
      let lon = coordinate[0]
      let lat = coordinate[1]
      let meters_per_lat = 2 * Math.PI * 6371393 / 360    //计算纬度单位度数的实际距离，单位米
      let meters_per_lon = meters_per_lat * Math.cos(lat * Math.PI / 180) //计算经度单位度数的实际距离，单位米
      let lon_length = length / meters_per_lon
      let lat_length = length / meters_per_lat

      let rec = []
      rec.push([lon - lon_length, lat - lat_length])
      rec.push([lon - lon_length, lat + lat_length])
      rec.push([lon + lon_length, lat + lat_length])
      rec.push([lon + lon_length, lat - lat_length])
      rec.push([lon - lon_length, lat - lat_length])

      //生成预览矩形
      let feature = new Feature({
        geometry: new Polygon([rec]).transform('EPSG:4326', 'EPSG:3857'),
      })
      that.source = new Vector({
          features: [feature],
        }),
      that.area_vector = new lVector({
        source: that.source,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0)' //填充颜色
          }),
          stroke: new Stroke({
            color: '#ffcc33', //边框颜色
            width: 2 // 边框宽度
          }),
        }),
      });

      that.map.addLayer(that.area_vector)
    
    
      //获取绘制图形范围
      var ext = that.area_vector.getSource().getExtent()
      //视角跳转到绘制图形
      that.map.getView().fit(ext)
      that.map.getView().setZoom(that.map.getView().getZoom())
      //面转为WKT格式
      const format = new fmtWKT()
      that.str_wkt = format.writeFeature(that.area_vector.getSource().getFeatures()[0], {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857',
      })
      that.str_area = tmpArea
      bus.$emit('buyDrawFinish')
    },
    drawArea() {
      let that = this
      //先取消全部监听，避免重复
      unByKey(this.key_move);
      unByKey(this.key_click);
      let kilometers = 1000000    //千米转化为米
      let tmpArea = 25;
      // let true_area = kilometers*100
      let true_area = kilometers*tmpArea
      let length = Math.sqrt(true_area) / 2

      //监听鼠标移动，实时绘制预览图形
      this.key_move = that.map.on('pointermove', function (e) {
        //先清除上一预览图形
        that.map.removeLayer(that.area_vector)

        //转换至经纬度计算，保证面积准确
        let lon = toLonLat(e.coordinate)[0]
        let lat = toLonLat(e.coordinate)[1]
        let meters_per_lat = 2 * Math.PI * 6371393 / 360    //计算纬度单位度数的实际距离，单位米
        let meters_per_lon = meters_per_lat * Math.cos(lat * Math.PI / 180) //计算经度单位度数的实际距离，单位米
        let lon_length = length / meters_per_lon
        let lat_length = length / meters_per_lat

        let rec = []
        rec.push([lon - lon_length, lat - lat_length])
        rec.push([lon - lon_length, lat + lat_length])
        rec.push([lon + lon_length, lat + lat_length])
        rec.push([lon + lon_length, lat - lat_length])
        rec.push([lon - lon_length, lat - lat_length])

        //生成预览矩形
        let feature = new Feature({
          geometry: new Polygon([rec]).transform('EPSG:4326', 'EPSG:3857'),
        })
        that.source = new Vector({
            features: [feature],
          }),
        that.area_vector = new lVector({
          source: that.source,
          style: new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0)' //填充颜色
            }),
            stroke: new Stroke({
              color: '#ffcc33', //边框颜色
              width: 2 // 边框宽度
            }),
          }),
        });

        that.map.addLayer(that.area_vector)
      })
      //监听地图点击事件，完成绘制
      this.key_click = that.map.once('click', function () {
        //取消全部地图监听
        unByKey(that.key_move);
        unByKey(that.right_click);
        //获取绘制图形范围
        var ext = that.area_vector.getSource().getExtent()
        //视角跳转到绘制图形
        that.map.getView().fit(ext)
        that.map.getView().setZoom(that.map.getView().getZoom() - 1)
        //面转为WKT格式
        const format = new fmtWKT()
        that.str_wkt = format.writeFeature(that.area_vector.getSource().getFeatures()[0], {
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:3857',
        })
        that.str_area = tmpArea
        bus.$emit('buyDrawFinish')
      })
    },
    makeBufferRegion(res){
      let that = this
      const format = new fmtWKT()
      if(res.data.data.area){
        that.str_area = res.data.data.area
      }else{
        that.str_area = res.data.data
      }
      if (res.data.needToBuffer) {
        let geojson=JSON.parse(res.data.data.geojson)
        let feature = new GeoJSON().readFeature(geojson, {
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:3857',
        })
        that.source.clear()
        that.source.addFeature(feature)
        that.str_wkt = format.writeFeature(feature, {
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:3857',
        })
        that.$message.warning('区域面积不足，已自动为您扩充至25km²')
      } else {
        that.str_wkt = format.writeFeature(that.source.getFeatures()[0], {
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:3857',
        })
      }
      
      //获取绘制图形范围
      var ext = that.source.getExtent()
      //视角跳转到绘制图形
      that.map.getView().fit(ext)
      that.map.getView().setZoom(that.map.getView().getZoom() - 1)
      
      bus.$emit('buyDrawFinish',that.str_wkt)
    },
      //缩放至功能坐标转换
      changeBboxFromLonLat(ext){
        let p1=[ext[0],ext[1]];
        let p2=[ext[2],ext[3]];
        p1=fromLonLat(p1);
        p2=fromLonLat(p2);
        return [p1[0],p1[1],p2[0],p2[1]];
      },

      //添加图例
      addLegend(layer){
        function setFormTable(layer){
          let lSource=layer.getSource();
          if (!lSource||!layer.values_.visible) {
            return;
          }
          if (lSource instanceof ImageArcGISRest||lSource instanceof TileArcGISRest) {//处理arcgis发布的服务
            let formTable = '';
            formTable += `<div name="${layer.values_.title}" class="legend_table">`;
            // formTable += `<div class="legend_tabletop"><div class="legend_tabtop_middle">${layer.values_.title}</div></div>`
            formTable += `<table class="formTable" style="width:100%">`;
            formTable += `<tr><td>`;
            //formTable += `<h3><b>${layer.values_.title}</b></h3>`;
            if (layer.values_.layersForLegend.layers) {
              layer.values_.layersForLegend.layers.forEach(ly=>{
                // formTable += `<b>${ly.layerName}(${ly.layerId})</b>`;
                formTable += `<table style="display: flex;">`;
                ly.legend.forEach(le=>{
                  if (!/band/i.test(le.label)) {
                    formTable += `<tr valign="middle"><td><img src="data:image/png;base64,${le.imageData}" style="width:${le.width};height:${le.height};" /></td>`;
                    formTable += `<td>${le.label}</td></tr>`;
                  }
                })
                formTable += `</table>`;
              })
            }
            formTable += `</td></tr>`;
            formTable += `</table>`;
            formTable += `</div>`;
            document.querySelector("#legend .rbody").innerHTML+=formTable;
          }
          if (lSource instanceof TileWMS||lSource instanceof Vector||lSource instanceof ImageWMS) {//处理geoserver发布的服务
            let formTable = '';
            formTable += `<div name="${layer.values_.title}" class="legend_table">`;
            // formTable += `<div class="legend_tabletop"><div class="legend_tabtop_middle">${layer.values_.title}</div></div>`
            formTable += `<table class="formTable" style="width:100%">`;
            formTable += `<tr><td>`;
            // formTable += `<h3><b>${layer.values_.title}</b></h3>`;
            layer.values_.layersForLegend.forEach(ly=>{
              formTable += `<table style="display: flex;"><tr valign="middle">`;
              formTable += `<td><img src="${ly.OnlineResource}" style="width:${ly.size[0]};height:${ly.size[1]};" /></td>`;
              if (ly.size[0]==ly.size[1]) {
                formTable += `<td>${layer.values_.title}</td></tr>`;
              }
              formTable += `</tr></table>`;
            })
            formTable += `</td></tr>`;
            formTable += `</table>`;
            formTable += `</div>`;
            document.querySelector("#legend .rbody").innerHTML+=formTable;
          }
        }

        if (layer instanceof Group) {
          layer.values_.layers.forEach(l=>{
            let divForDeleteLegend = document.querySelector(`div[name='${l.values_.title}']`);
            if (!divForDeleteLegend&&l.values_.title!='吉林省图层') {
              setFormTable(l);
            }
          })
        }else{
          let divForDeleteLegend = document.querySelector(`div[name='${layer.values_.title}']`);
          if (!divForDeleteLegend&&layer.values_.title!='吉林省图层') {
            setFormTable(layer);
          }
        }
      },
      //移除图例
      deleteLegend(layer){
        let that=this;
        if (layer instanceof Group) {
          layer.values_.layers.forEach(l=>{
            let divForDeleteLegend = document.querySelector(`div[name='${l.values_.title}']`);
            if (divForDeleteLegend&&divForDeleteLegend.parentNode) {
              divForDeleteLegend.parentNode.removeChild(divForDeleteLegend);//删除对应图例
            }
          })
        }else{
          let divForDeleteLegend = document.querySelector(`div[name='${layer.values_.title}']`);
          if (divForDeleteLegend&&divForDeleteLegend.parentNode) {
            divForDeleteLegend.parentNode.removeChild(divForDeleteLegend);//删除对应图例
          }
        }

      },

      triggerBus(busName){
        bus.$emit(busName);
      },

      sliderChange(value){
        let that=this;
        function setV(qs){
           that.map.getLayers().forEach(layer=>{
            if (layer instanceof Group&&layer.values_.title!="天地图服务") {
              if (layer.values_.title===qs) {
                layer.setVisible(true);
                layer.values_.layers.forEach(ly=>{
                  if (ly instanceof Tile) {
                    ly.setVisible(true);
                  }
                })
                that.addLegend(layer);
                that.addToModelist(layer, "juanlianList1");
                that.addToModelist(layer, "juanlianList2");
              }else{
                if (layer.values_.title!=='矢量图层') {
                  layer.setVisible(false);
                  layer.values_.layers.forEach(ly=>{
                    if (ly instanceof Tile) {
                      ly.setVisible(false);
                    }
                  })
                  that.deleteLegend(layer);
                  that.deleteFromModelist(layer,"juanlianList1");//从卷帘面板列表中删除
                  that.deleteFromModelist(layer,"juanlianList2");//从卷帘面板列表中删除
                }
              }
            }
            if (layer instanceof Tile) {
               if (layer.values_.title===qs) {
                layer.setVisible(true);
                that.addLegend(layer);
                that.addToModelist(layer, "juanlianList1");
                that.addToModelist(layer, "juanlianList2");
              }else{
                layer.setVisible(false);
                that.deleteLegend(layer);
                that.deleteFromModelist(layer,"juanlianList1");//从卷帘面板列表中删除
                that.deleteFromModelist(layer,"juanlianList2");//从卷帘面板列表中删除
              }
            }
          })
        }
        switch (value) {
          case 0:setV("第一期");break;
          case 33.3:setV("第二期");break;
          case 66.6:setV("第三期");break;
          case 100:setV("第四期");break;
          default:
            break;
        }
      },

      changeCQL(){
        let inputs=document.querySelectorAll('.lyrPanal [type="checkbox"]:checked');
        let ltlxCQLsFromHome=new Set();
        let statusNotBlingCQLs=new Set();
        let statusBlingCQLs=new Set();
        this.cqlUrl=this.black_waterPointUrl;
        // this.cqlUrl1=this.black_waterUrl;
        this.checkedNames=[];
        inputs.forEach(i=>{
          let name=i.getAttribute('name')
          let cql=i.getAttribute('data-cql')
          let dataName=i.getAttribute('data-name')
          this.checkedNames.push(name);
          /* if (dataName=='ltlx') {
            ltlxCQLsFromHome.add(cql);
          } */
          if (dataName=='status') {
            // if (name=='未调查'||name=='销号') {
            if (name=='销号') {
              statusNotBlingCQLs.add(cql);
            }else{
              statusBlingCQLs.add(cql);
            }
            /* if (name=='卫星纠错') {
              this.cqlUrl=this.black_waterPointWeiXingShenHeUrl;
              this.cqlUrl1=this.black_waterWeiXingShenHeUrl;
            } */
          }
        })

        let ltlxCQL=Array.from(ltlxCQLsFromHome).join(' or ');
        let statusBlingCQL=Array.from(statusBlingCQLs).join(' or ');
        let statusNotBlingCQL=Array.from(statusNotBlingCQLs).join(' or ');
        let cqlArr1=[];//(裸土类型or裸土类型)&&(销号or未调查)
        let cqlArr2=[];//(裸土类型or裸土类型)&&(销号or未调查)or((裸土类型or裸土类型)&&(未审核or未整改or卫星纠错))
        if (ltlxCQL!=''){
           cqlArr1.push(`(${ltlxCQL})`);
           cqlArr2.push(`(${ltlxCQL})`);
        }
        if (statusNotBlingCQL!=''){
           cqlArr1.push(`(${statusNotBlingCQL})`);
           cqlArr2.push(`(${statusNotBlingCQL})`);
        }
        if (statusBlingCQL!=''){
           cqlArr2.push(`(${statusBlingCQL})`);
        }

        let newCQL1=cqlArr1.join(' && ');
        let newCQL2='';
        if (cqlArr2.length==3) {
          newCQL2=`${cqlArr2[0]} && ${cqlArr2[1]} or (${cqlArr2[0]} && (${cqlArr2[2]}))`;
        } else {
          if (statusNotBlingCQL!=''&&statusBlingCQL!=''){
            newCQL2=cqlArr2.join(' or ');
          }
          else {
            newCQL2=cqlArr2.join(' && ');
          }
        }
        if (newCQL1=='') newCQL1=null;
        if (newCQL2=='') newCQL2=null;
        return newCQL1+'-'+newCQL2;
      },
      setBlingStatus(newCQL){
        let cqls=newCQL.split('-');
        for (let i = 0; i < cqls.length; i++) {
          if (cqls[i]=='null') cqls[i]='';
        }
        if (this.checkedNames.includes('未核查')||this.checkedNames.includes('核查未审核')||this.checkedNames.includes('重新核查')||this.checkedNames.includes('未整改')
        ||this.checkedNames.includes('整改未完成')||this.checkedNames.includes('整改未审核')||this.checkedNames.includes('整改通过')) {//闪烁
          if (this.checkedNames.length==1||!/status/.test(cqls[0])) {//如果只有一个勾选了(且有这三种状态（闪烁）肯定在cqls[1]里)，或者前一个cql里只有ltlx
            cqls[0]=`(status='40')`;//用于去掉全部图斑
          }
          /* if (this.checkedNames.includes('销号')&&this.checkedNames.includes('卫星纠错')) {//同时有销号和卫星纠错的，不管其他状态了
            cqls[1]=`(status='32' && pszt='未整改' && psrq like '%07%')`//每次闪烁新一期
          } */
          let i=1;
          clearInterval(this.cqlInterval);
          this.cqlInterval=null;

          this.cqlInterval=setInterval(()=>{
            if (i>1) i=0;
            if (this.checkedNames.includes('销号')&&i==0) {//同时有销号和卫星纠错的
              bus.$emit('refreshMapByQueryCQL',cqls[i],this.cqlUrl,/point/i);  //cqls[i]  一定为status = 33 or status = 36
            }else{
              bus.$emit('refreshMapByQueryCQL',cqls[i],this.cqlUrl,/point/i);
              //bus.$emit('refreshMapByQueryCQL',cqls[i],this.cqlUrl1,/解译结果$/i);
            }
            i++;
          },1000);

          // setTimeout(()=>{
          //   bus.$emit('refreshMapByQueryCQL',cqls[1],this.cqlUrl1,/解译结果$/i);
          // },1000)
        }else{
          clearInterval(this.cqlInterval);
          this.cqlInterval=null;
          bus.$emit('refreshMapByQueryCQL',cqls[1],this.cqlUrl,/point/i);
          // bus.$emit('refreshMapByQueryCQL',cqls[1],this.cqlUrl1,/解译结果$/i);
        }
      },

      clickLyrPanal(){
        let newCQL=this.changeCQL();
        this.setBlingStatus(newCQL);
      },
      toggleBling(){
        let newCQL=this.changeCQL();
        if (this.cqlInterval!=null){
          let cqls=newCQL.split('-');
          clearInterval(this.cqlInterval);
          this.cqlInterval=null;
          bus.$emit('refreshMapByQueryCQL',cqls[1],this.cqlUrl,/point/i);
          // bus.$emit('refreshMapByQueryCQL',cqls[1],this.cqlUrl1,/解译结果$/i);
        }else{
          this.setBlingStatus(newCQL);
        }
      },
      downloadMyShp(f) {
      let geos = [];
      let properties = [];
      let pSet = new Set()
      
        let fCloned = f.clone()
        let fClonedGeometry = fCloned.getGeometry()
        fClonedGeometry.transform(this.mapParams.projection, 'EPSG:4326')
        let type = f.getGeometry().getType()
        let coordinates, coorArr = []
        if (type != 'MultiPolygon') {
          coordinates = Array.from(fClonedGeometry.flatCoordinates)

          for (let i = 0; i < coordinates.length; i = i + 2) {
            coorArr.push([coordinates[i], coordinates[i + 1]])
          }
          console.log('coorArr', [coorArr])
        }
        let keys = Object.keys(f.values_)
        let values = Object.values(f.values_)
        let propertie = {}
        keys.forEach((v, index) => {
          if (v != 'geometry') {
            propertie[v] = values[index]
          }
        })
        properties.push(propertie)
        if (type == 'MultiPolygon') {
          // let polygon=turf.multiPolygon([[coorArr]])
          let polygon = JSON.parse(new GeoJSON().writeFeature(fCloned));//转为geojson
          // console.log(polygon);
          geos.push(polygon);
        }
        if (type == 'Polygon') {
          let polygon = turf.polygon([coorArr])
          geos.push(polygon);
        }
        if (type == 'LineString') {
          let lineString = turf.lineString(coorArr)
          geos.push(lineString);
        }
        pSet.add(type)
      if (Array.from(pSet).length > 1) {
        this.$message.warning('不能同时下载多种类型图斑！')
        return
      }

      this.overlay = true
      let wkts = geos.map(v => WKT.convert(v.geometry))
      console.log('wkts', wkts)
      this.axios({
        method: "post",
        url: '/koa_back/createShp',
        // url:'/accessapi/demandService/shapeOperation/generateShape',
        headers: {
          'Content-type': 'application/json'
        },
        data: { wkts: wkts, name: '导出矢量', properties: JSON.stringify(properties) }
      })
        .then(res => {
          this.overlay = false
          function downloadBase64File(base64Data, fileName) {
            const link = document.createElement('a');
            link.download = fileName;
            link.href = base64Data;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          downloadBase64File(res.data.result, '导出矢量.zip')
        })
    },
      featuresTo84MultiPolygon(features) {
        let geos=[];
          // let pSet=new Set()  
          // let features = this.source.getFeatures()
          features.forEach(f => {
            let fCloned=f.clone()
            let fClonedGeometry=fCloned.getGeometry()
            fClonedGeometry.transform(this.mapParams.projection, 'EPSG:4326')
            let type = f.getGeometry().getType()
            let coordinates,coorArr=[]
            if (type!='MultiPolygon') {
              coordinates = Array.from(fClonedGeometry.flatCoordinates)
              
              for (let i = 0; i < coordinates.length; i=i+2) {
                coorArr.push([coordinates[i],coordinates[i+1]])
              }
              console.log('coorArr',[coorArr])
            }
            if (type=='MultiPolygon') {
              // let polygon=turf.multiPolygon([[coorArr]])
              let polygon = JSON.parse(new GeoJSON().writeFeature(fCloned));//转为geojson
              geos.push(polygon);
            }
            if (type=='Polygon') {
              let polygon=turf.polygon([coorArr])
              geos.push(polygon);
            }
            if (type=='LineString') {
              let lineString=turf.lineString(coorArr)
              geos.push(lineString);
            }
            if (type == 'Circle') {
              var center = coorArr[0];
              var radius = coorArr[1][0]-coorArr[0][0];
              var options = { steps: 64, units: 'degrees' };
              var turfCircle = circle(center, radius, options);
              geos.push(turfCircle);
            }
          
            // pSet.add(type)
          })
          // if (Array.from(pSet).length>1) {
          //   this.$message.warning('不能同时加入多种类型图斑！')
          //   return
          // }
          let myFeatures = []
          let geoType=''  
          geos.forEach(g => {
            let geo
            switch (g.geometry.type) {
              case 'Polygon':
                geo = new Polygon(g.geometry.coordinates)
                geoType= 'Polygon'
                break;
              case 'MultiPolygon':
                geo = new MultiPolygon(g.geometry.coordinates)
                geoType= 'MultiPolygon'
                break;
              case 'LineString':
                geo = new LineString(g.geometry.coordinates)
                geoType= 'LineString'
                break;
              // case 'MultiLineString':
                
              //   break;
            
              default:
                break;
            }
            let feature = new Feature({
              geometry: geo
            })
            myFeatures.push(feature)
          })

          let featureGeoJson,multi
          // if (geoType=='MultiPolygon') {
          //   myFeatures.forEach(f => {
          //     featureGeoJson = JSON.parse(new GeoJSON().writeFeature(f));//转为geojson
          //   })
          // } else {
            multi = GeometryToMulti(myFeatures,geoType)//转成多
            featureGeoJson = JSON.parse(new GeoJSON().writeFeature(multi));//转为geojson
          // }
        console.log(featureGeoJson);
          
        return featureGeoJson
      }
    },
    mounted() {
    //   bus.$off("myevent");
    // bus.$on("myevent", (param) => {
    //   this.fullScreen = param;
    //   console.log(this.fullScreen)
    // });
      // let user=localStorage.getItem('pro__Login_Userinfo');
      // let dp=JSON.parse(user).value.departname;
      // if (dp) {
      //   this.departname=dp.split('-');
      // }

      // let href=window.location.href;
      // if (/DataManagement/i.test(href)) {
      //   this.cqlFromPage=null;
      // }else if (/DataAuditing/i.test(href)) {
      //   //this.cqlFromPage=`status='31' and cxhc is null`;
      //   this.cqlFromPage=`status='31'`;
      // }else if (/TaskRectifyCheck/i.test(href)) {
      //   //this.cqlFromPage=`status='31' and cxhc='1'`;
      //   this.cqlFromPage=`status='35'`;
      // }else{
      //   this.cqlFromPage='';
      // }

      // this.getLyrServices()
      this.loadGisMap();
      //console.log(this.map)

      bus.$off('refreshMapByQuery');
      bus.$on('refreshMapByQuery',(queryParam,status)=>{
        this.map.getLayers().forEach(layer=>{
          if (layer instanceof Group) {
            layer.values_.layers.forEach(l=>{
              if (l.values_.visible&&(l.getSource() instanceof ImageWMS||l.getSource() instanceof TileWMS)&&(/解译/i.test(l.values_.title))) {
                let params=l.getSource().getParams();
                let cql=``;
                // if (status==`31`) cql+=`status='31'`;
                if (this.cqlFromPage!=''&&this.cqlFromPage!=null) {
                  cql+=this.cqlFromPage;
                }

                if (this.departname.length==1) {
                  if (cql==``) cql+=`city like '%${this.departname[0]}%'`;
                  else cql+=`&&city like '%${this.departname[0]}%'`;
                }
                if (this.departname.length==2) {
                  if (cql==``) cql+=`city like '%${this.departname[0]}%'&&depart like '%${this.departname[1]}%'`;
                  else cql+=`&&city like '%${this.departname[0]}%'&&depart like '%${this.departname[1]}%'`;
                }
                // for (const key in queryParam) {
                //   if (queryParam.hasOwnProperty(key)) {
                //     let keyName=key;
                //     let element = queryParam[keyName];
                //     if (keyName=='smelly') {
                //       cql+=`&&${keyName}='${element}'`;
                //     }else{
                //       if (keyName=='departName') {
                //       if (/^市/.test(element)) keyName='depart';
                //       else keyName='city';
                //       }
                //       if (cql==``) cql+=`${keyName} like '%${element}%'`;
                //       else cql+=`&&${keyName} like '%${element}%'`;
                //     }
                //   }
                // }
                if (!(queryParam.number||queryParam.status)) {//如果有地块编码或状态就不按照状态查询，即使该图斑状态不属于对应清单里的，特殊需求。。
                  if (this.cqlFromTab!='') {
                    if (cql==``) cql=this.cqlFromTab;
                    else cql+=`&&${this.cqlFromTab}`;
                  }
                }
                if (cql==``) cql=null;
                params.CQL_FILTER=cql;
                //console.log(cql);
                l.getSource().updateParams(params);

              }
            })
          }
        })
      })

      bus.$off('refreshMapByQueryCQL');
      bus.$on('refreshMapByQueryCQL',(CQL,url,regExp)=>{
        this.map.getLayers().forEach(layer=>{
          if (layer instanceof Group) {
            layer.values_.layers.forEach(l=>{
              if (l.values_.visible&&(l.getSource() instanceof ImageWMS||l.getSource() instanceof TileWMS)&&(regExp.test(l.values_.title))) {
                let params=l.getSource().getParams();
                let cql=CQL;
                this.cqlFromTab=CQL;
                if (url!='') {
                  l.getSource().url_=url;
                }
                if (cql==``) cql=null;
                params.CQL_FILTER=cql;
                //console.log(cql);
                l.getSource().updateParams(params);
              }
            })
          }
        })
      })

      bus.$off('showUploadVector');
      bus.$on('showUploadVector', geoJson => {
        // TODO 显示点线
        this.uploadAndSelectVector=geoJson
        let geometry//判断多种类型的矢量
      if (geoJson.type == 'GeometryCollection') {//collection格式矢量判断类别后逐一添加
        this.source.clear()
        if (geoJson.geometries[0].type == 'MultiPolygon') {
          geoJson.geometries.forEach(geo => {
            geometry = new MultiPolygon(geo.coordinates)
            let feature = new Feature({
              geometry: geometry
            })
            feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
            this.source.addFeature(feature)
          });
          
        }
        if (geoJson.geometries[0].type == 'Polygon') {
          
          geoJson.geometries.forEach(geo => {
            geometry = new Polygon(geo.coordinates)
            let feature = new Feature({
              geometry: geometry
            })
            feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
            this.source.addFeature(feature)
          });
        }
        if (geoJson.geometries[0].type == 'LineString') {
          
          geoJson.geometries.forEach(geo => {
            geometry = new LineString(geo.coordinates)
            let feature = new Feature({
              geometry: geometry
            })
            feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
            this.source.addFeature(feature)
          });
        }
        if (geoJson.geometries[0].type == 'MultiLineString') {
          
          geoJson.geometries.forEach(geo => {
            geometry = new MultiLineString(geo.coordinates)
            let feature = new Feature({
              geometry: geometry
            })
            feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
            this.source.addFeature(feature)
          });
        }
        
      }
      else {//单一格式矢量类型
        if (geoJson.type == 'MultiPolygon') {
          geometry = new MultiPolygon(geoJson.coordinates)
        }
        if (geoJson.type == 'Polygon') {
          geometry = new Polygon(geoJson.coordinates)
        }
        if (geoJson.type == 'LineString') {
          geometry = new LineString(geoJson.coordinates)
        }
        if (geoJson.type == 'MultiLineString') {
          geometry = new MultiLineString(geoJson.coordinates)
        }
        let feature = new Feature({
          geometry: geometry
        })
        feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
        this.source.clear()
        this.source.addFeature(feature)
      }
        this.map.removeLayer(this.vector)
        this.map.addLayer(this.vector)
        let ext = this.source.getExtent()
        this.map.getView().fit(ext)//先这么跳着，有矢量就跳矢量
        if(this.needEmit){this.drawFinished = false}
        else if (this.isLeftVector) this.leftdrawFinished = true//判断是否左侧绘制
        else {
          this.drawFinished = true
        }
      })

      this.parentContainer = this.Search;
      this.axios.get('/accessapi/searchService/Area/id=-1').then((res) => {
          this.chinaProvinceItems = res.data.data
      })
      this.axios.get("/accessapi/searchService/countryList").then((res) => {
          this.countryItems = res.data.data
      })
    },
    created() {
     
    this.initMapCtrlTools()
    },
    computed: {
      lyrBox: function() {
        return 'lyrBoxDiv' + new Date().valueOf()
      }
    },
    watch: {
      chinaProvinceNow () {
          this.chinaCityNow = ''
          this.chinaCountyNow = ''
          this.chinaCityItems = []
          this.chinaCountyItems = []
          this.$refs.chinaCity.lazySearch = ''
          this.$refs.chinaCounty.lazySearch = ''
          if (this.chinaProvinceNow !== ''){
              this.axios.get('/accessapi/searchService/Area/id=' + this.chinaProvinceNow)
                  .then((res) => {
                      this.chinaCityItems = res.data.data
                  })
              this.$store.state.search.selectedRangeStore['china'] = JSON.parse(this.chinaProvinceItems.find((x)=>{return x.areaId === this.chinaProvinceNow}).areaGeojson)
              bus.$emit('showUploadVector',JSON.parse(this.chinaProvinceItems.find((x)=>{return x.areaId === this.chinaProvinceNow}).areaGeojson))
          }
      },
      chinaCityNow () {
          this.chinaCountyNow = ''
          this.chinaCountyItems = []
          this.$refs.chinaCounty.lazySearch = ''
          if (this.chinaCityNow !== '')
          {
              this.axios.get('/accessapi/searchService/Area/id=' + this.chinaCityNow)
                  .then((res) => {
                      this.chinaCountyItems = res.data.data
                  })
              this.$store.state.search.selectedRangeStore['china'] = JSON.parse(this.chinaCityItems.find((x)=>{return x.areaId === this.chinaCityNow}).areaGeojson)
              bus.$emit('showUploadVector',JSON.parse(this.chinaCityItems.find((x)=>{return x.areaId === this.chinaCityNow}).areaGeojson))
          }
      },
      chinaCountyNow () {
          if (this.chinaCountyNow !== '') {
              this.$store.state.search.selectedRangeStore['china'] = JSON.parse(this.chinaCountyItems.find((x) => {return x.areaId === this.chinaCountyNow}).areaGeojson)
              bus.$emit('showUploadVector',JSON.parse(this.chinaCountyItems.find((x) => {return x.areaId === this.chinaCountyNow}).areaGeojson))

          }
      },
      countryNow () {
          this.$store.state.search.selectedRangeStore['world'] = JSON.parse(this.countryNow)
      },
    },
    destroyed(){
      //每次跳转页面先清空定时器
      clearInterval(this.cqlInterval);
      this.cqlInterval=null;
      this.distroyKeys()
    }
  }
</script>
<style scoped>
  /* @import '~ol-ext/dist/ol-ext.css'; */
  @import '~ol-ext/dist/ol-ext.css';
  @import '../../assets/mapIcon/mapctrl/my-ol-ext.css';
  @import url('../../assets/less/mainMap.less');
  .mytool-btns2 {
    position: absolute;
    z-index: 3;
    top: 3.5rem;
    /* left:0.07rem; */
  }
  .mytool-btns2-home {
    position: absolute;
    z-index: 3;
    top:1.9rem;
    left: 13.9rem;
  }
</style>

<style>
  @import url('../../assets/less/customOl.less');
</style>

<style lang="scss" scoped>
  .map_tool_shp{
    position: absolute;
    bottom: 500px;
    right: 21px;
    width: 68px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .tool_background{
      width: 40px;
      height: 40px;
      background-color: rgb(0, 0, 0, 0.5);
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-bottom: 2px;
    }
    .tool_background:hover{
      background-color: rgb(0, 0, 0, 0.75);
    }
  }
  .map_tool{
    position: absolute;
    bottom: 70px;
    right: 21px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .btn{
      position: relative;
      cursor: pointer;
      .vectorPanel{
        position: absolute;
        right: 10px;
        >div{
          position: absolute;
          width: 40px;
          height: 40px;
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .addVector{
          transform: translate(-75px, -40px);
        } 
        .selectRegion{
          transform: translate(-120px, -40px);
        }
        .drawLine{
          transform: translate(-165px, -40px);
        }
        .drawPolygon{
          transform: translate(-210px, -40px);
        }

        /* .selectRegion{
          transform: translate(-75px, -40px);
        }
        .drawLine{
          transform: translate(-120px, -40px);
        }
        .drawPolygon{
          transform: translate(-165px, -40px);
        } */
        .clean{
          transform: translate(-255px, -40px);
        }
        .clean1 {
        transform: translate(-75px, -40px);
      }
      }
      .measurePanel{
        position: absolute;
        right: 10px;
        // width: 85px;
        // z-index: 3;
        // box-shadow: 1px 1px 5px #888888;
        // border-radius: 5px;
        // background-color: rgb(38,46,50);
        // border-radius: 5px;
        // color: #00d5ff;
        // transform: translate(-40px, -40px);
        // display: flex;
        // justify-content: center;
        // flex-direction: column;
        // align-items: center;
        // >div{
        //   width: 100%;
        //   border-bottom: 1px solid #b4b4b4;
        //   text-align: center;
        //   height: 30px;
        //   line-height: 30px;
        // }
        >div{
          position: absolute;
          width: 40px;
          height: 40px;
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
          .distance{
            transform: translate(-75px, -40px);
          }
          .area{
            transform: translate(-120px, -40px);
          }
          .clean{
            transform: translate(-165px, -40px);
          }
          .clean1 {
        transform: translate(-75px, -40px);
      }
      }
      .small_img{
        width: 40px;
        height: 40px;
      }
      .zoomOut{
        // margin-top: 5px;
        // pointer-events: none;
      }
      .zoomIn{
        // pointer-events: none;
      }
    }
    .zoomPanel{
      position: relative;

      cursor:unset;
      .zoomSpan{
        background: url("../../assets/RSsserviceManage/等级.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        // position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: white;
        width: 68px;
        height: 68px;
        margin-top: -5px;
        margin-bottom: -4px;
      }
      .zoomTitle{
        font-size: 10px;
        font-family: Arial-ItalicMT, Arial;
        font-weight: normal;
        color: #979797;
        line-height: 11px;
      }
      .zoomValue{
        font-size: 12px;
        font-family: ArialMT;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 5px;
      }
    }
  }
  ::v-deep .ol-zoom-in{
    display: none;
  }
  ::v-deep .ol-zoom-out{
    display: none;
  }
  .countyTip{
    position: absolute;
    left: calc(50% - 200px);
    top: calc(50% - 50px);
    width: 400px;
    height: 100px;
    background: rgba(0,0,0,0.5);
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
  }
</style>


<style scoped>
.image-view-root {
  position: relative;
}
.ivm-flow-modal-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 20050;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  box-sizing: border-box;
}
.ivm-flow-modal {
  position: relative;
  width: 600px;
  max-width: calc(100vw - 48px);
  padding: 50px 80px;
  background: rgba(45, 45, 45,1);
  border-radius: 12px;
  box-sizing: border-box;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
}
.ivm-flow-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.ivm-flow-modal-title {
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;
  font-weight: 500;
  color: #ffffff;
  line-height: 22px;
  margin-bottom: 20px;
}
.ivm-flow-modal-body {
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC, sans-serif;
  font-weight: 300;
  color: #ffffff;
  line-height: 22px;
  margin-bottom: 28px;
}
.ivm-flow-modal-body p {
  margin: 0;
}
.ivm-flow-modal-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.ivm-flow-modal-btn {
  min-width: 112px;
  height: 36px;
  padding: 0 20px;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  cursor: pointer;
  border: none;
  outline: none;
  box-sizing: border-box;
}
.ivm-flow-modal-btn-primary {
  background: #1890ff;
  color: #ffffff;
}
.ivm-flow-modal-btn-primary:hover {
  background: #40a9ff;
}
.ivm-flow-modal-btn-ghost {
  background: transparent;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.65);
}
.ivm-flow-modal-btn-ghost:hover {
  border-color: #ffffff;
}
</style>